(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);throw new Error("Cannot find module '"+o+"'")}var f=n[o]={exports:{}};t[o][0].call(f.exports,function(e){var n=t[o][1][e];return s(n?n:e)},f,f.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CustomStickerApp = undefined;

var _htmlToImage = require('html-to-image');

var htmlToImage = _interopRequireWildcard(_htmlToImage);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var CONFIG = {
    title: {
        maxLines: 3,
        maxLineLength: 13,
        get maxTotalLength() {
            return this.maxLines * this.maxLineLength;
        }
    },
    message: {
        maxLines: 2,
        maxLineLength: 32,
        get maxTotalLength() {
            return this.maxLines * this.maxLineLength;
        }
    }
};

var SELECTORS = {
    sidebar: '.js-custom-sticker-sidebar',
    slideOut: '.js-slide-out',
    body: '.js-body',
    cartSidebar: '.js-cart-sidebar',
    preview: {
        wrapper: '.js-custom-sticker-product-page-preview',
        message: '.js-custom-sticker-message-preview',
        title: '.js-custom-sticker-title-preview',
        image: '.custom-sticker-preview__image'
    },
    form: '.js-custom-sticker-form',
    content: '.js-custom-sticker-content',
    widgets: {
        main: '.js-custom-sticker-widget',
        alreadyExists: '.js-custom-sticker-already'
    },
    counters: {
        message: '.js-custom-sticker-message-counter',
        title: '.js-custom-sticker-title-counter'
    },
    inputs: {
        message: '.js-custom-sticker-message',
        title: '.js-custom-sticker-title',
        inputs: '.js-custom-sticker-input',
        messageHTML: '.js-custom-message-html',
        titleHTML: '.js-custom-title-html'
    }
};

var UIController = {
    showSidebar: function showSidebar() {
        var sidebar = document.querySelector(SELECTORS.sidebar);
        var slideOut = document.querySelector(SELECTORS.slideOut);
        var body = document.querySelector(SELECTORS.body);

        if (sidebar && slideOut) {
            sidebar.style.width = null;
            slideOut.classList.add('slide-out--is-open');
            body.classList.add('overflow-hidden');
        }
    },
    closeSidebar: function closeSidebar() {
        var sidebar = document.querySelector(SELECTORS.sidebar);
        var slideOut = document.querySelector(SELECTORS.slideOut);
        var body = document.querySelector(SELECTORS.body);
        var cartSidebarIsOpen = document.querySelector(SELECTORS.cartSidebar).offsetWidth > 0;

        if (sidebar.style.width !== '0px') {
            sidebar.style.width = '0px';
            if (!cartSidebarIsOpen) {
                slideOut.classList.remove('slide-out--is-open');
                body.classList.remove('overflow-hidden');
            }
        }
    },
    processText: function processText(text, config) {
        var maxLines = config.maxLines,
            maxLineLength = config.maxLineLength;


        var words = text.split(' ').filter(function (word) {
            return word.length > 0;
        });

        var formattedLines = [];
        var currentLine = '';

        for (var i = 0; i < words.length; i++) {
            var currentWord = words[i];

            var safeWord = currentWord.substring(0, maxLineLength);

            if (currentLine.length === 0) {
                currentLine = safeWord;
            } else if (currentLine.length + safeWord.length + 1 <= maxLineLength) {
                currentLine += ' ' + safeWord;
            } else {
                formattedLines.push(currentLine);
                currentLine = safeWord;

                if (formattedLines.length >= maxLines - 1) {

                    var lastLineSpace = maxLineLength - currentLine.length;

                    for (var j = i + 1; j < words.length; j++) {
                        var nextWord = words[j];

                        if (lastLineSpace >= nextWord.length + 1) {
                            currentLine += ' ' + nextWord;
                            lastLineSpace -= nextWord.length + 1;
                        } else if (lastLineSpace > 1) {
                            currentLine += ' ' + nextWord.substring(0, lastLineSpace - 1);
                            break;
                        } else {
                            break;
                        }
                    }
                    break;
                }
            }
        }

        if (currentLine.length > 0 && formattedLines.length < maxLines) {
            formattedLines.push(currentLine);
        }

        return formattedLines;
    },


    sanitizeInput: function sanitizeInput(text) {
        // Prohibit pipes
        var sanitized = text.replace(/\|/g, '');
        sanitized = sanitized.replace(/[´`]/g, "'");

        // Prohibit non latin caracter
        sanitized = sanitized.replace(/[^A-Za-zÀ-ÖØ-öø-ÿĀ-ſƀ-ɏ0-9\s.,;:!?'’"()\-–—]/g, '');

        // Prohibit emojis
        sanitized = sanitized.replace(/(\u00a9|\u00ae|[\u2000-\u2018\u201A-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])/g, '');
        return sanitized;
    },

    updatePreview: function updatePreview() {
        var titleInput = document.querySelector(SELECTORS.inputs.title);
        var messageInput = document.querySelector(SELECTORS.inputs.message);
        var titlePreview = document.querySelector(SELECTORS.preview.title);
        var messagePreview = document.querySelector(SELECTORS.preview.message);
        var titleHTML = document.querySelector(SELECTORS.inputs.titleHTML);
        var messageHTML = document.querySelector(SELECTORS.inputs.messageHTML);

        var processedTitleLines = UIController.processText(titleInput.value, CONFIG.title).join('<br />');
        titlePreview.innerHTML = processedTitleLines;
        titleHTML.value = processedTitleLines;

        var processedMessageLines = UIController.processText(messageInput.value, CONFIG.message).join('<br />');
        messagePreview.innerHTML = processedMessageLines;
        messageHTML.value = processedMessageLines;
    },
    updateCounter: function updateCounter(type) {
        var preview = document.querySelector(SELECTORS.preview[type]);
        var counter = document.querySelector(SELECTORS.counters[type]);
        var _CONFIG$type = CONFIG[type],
            maxTotalLength = _CONFIG$type.maxTotalLength,
            maxLineLength = _CONFIG$type.maxLineLength;


        var value = preview.innerHTML;
        var lines = [];
        var totalLength = 0;

        if (value) {
            lines = value.split(/<br\s*\/?>/gi);
            var lastPartLength = lines.length > 0 ? lines[lines.length - 1].length : 0;
            totalLength = (lines.length - 1) * maxLineLength + lastPartLength;
        }

        counter.textContent = totalLength + '/' + maxTotalLength;

        var color = '#666';
        if (totalLength >= maxTotalLength) {
            color = '#ff0000';
        } else if (totalLength >= maxTotalLength * 0.7) {
            color = '#ff9900';
        }
        counter.style.color = color;
    },
    updateCounters: function updateCounters() {
        this.updateCounter('message');
        this.updateCounter('title');
    }
};

var APIService = {
    getCustomSticker: function getCustomSticker(productId, stickerId) {
        return fetch('/get-custom-sticker?productId=' + productId + '&stickerId=' + stickerId).then(function (response) {
            return response.json();
        });
    },

    saveCustomSticker: function saveCustomSticker(formData) {
        return fetch('/save-custom-sticker', {
            method: 'POST',
            body: formData
        }).then(function (response) {
            return response.json();
        });
    }
};

var EventHandlers = {
    handleTextInput: function handleTextInput(event, config) {
        var input = event.target;
        var text = input.value;

        var sanitizedText = UIController.sanitizeInput(text);
        if (sanitizedText !== text) {
            input.value = sanitizedText;
            text = sanitizedText;
        }

        var processedLines = UIController.processText(text, config);
        var processedText = processedLines.join(' ');

        if (processedText.trim() !== text.trim()) {
            input.value = processedText;
        }

        UIController.updatePreview();
        UIController.updateCounters();
    },
    handleCustomStickerSelection: function handleCustomStickerSelection(event) {
        var previewWrapper = document.querySelector(SELECTORS.preview.wrapper);

        if (event.target.checked && previewWrapper.children.length === 0) {
            CustomStickerApp.showCustomStickerSidebar(event);
        }
    },
    handleFormSubmit: function handleFormSubmit(event) {
        event.preventDefault();
        var form = event.target;
        var formData = new FormData(form);
        var previewElement = document.querySelector('.custom-sticker__preview');
        var tempImage = void 0;

        var htmlToImageConfig = { cacheBust: true };
        if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1) {
            htmlToImageConfig = { cacheBust: true, skipFonts: true };
        }

        htmlToImage.toPng(previewElement, htmlToImageConfig).then(function (customStickerImage) {
            tempImage = customStickerImage;
            formData.append('custom_sticker[image]', customStickerImage);
            return APIService.saveCustomSticker(formData);
        }).then(function (data) {
            if (data.success) {
                UIController.closeSidebar();
                document.querySelectorAll(SELECTORS.preview.image).forEach(function (image) {
                    return image.src = tempImage;
                });
                document.querySelector(SELECTORS.preview.wrapper).innerHTML = data.message.preview;
            }
        }).catch(function (error) {
            return console.error('Error:', error);
        });
    }
};

var CustomStickerApp = exports.CustomStickerApp = {
    init: function init() {
        var _this = this;

        if (!window.customStickerInitialized) {
            document.addEventListener('DOMContentLoaded', function () {
                return _this.initializeSidebarControls();
            }, { once: true });
            window.customStickerInitialized = true;
        }
    },
    initializeAll: function initializeAll() {
        this.initializeCustomStickerInputs();
        UIController.updatePreview();
        UIController.updateCounters();
    },
    initializeSidebarControls: function initializeSidebarControls() {
        var _this2 = this;

        var closeButtons = document.querySelectorAll('.js-close-custom-sticker-sidebar');
        var options = document.querySelectorAll('.js-custom-sticker-option');
        var slideOut = document.querySelector(SELECTORS.slideOut);

        document.body.addEventListener('click', function (e) {
            var openButton = e.target.closest('.js-open-custom-sticker');
            if (openButton) {
                _this2.showCustomStickerSidebar({ currentTarget: openButton });
            }
        });

        // Display custom sticker sidebar when the user wants to add a product with a custom sticker that they haven't personalized yet
        document.addEventListener('click', function (event) {
            if (event.target.closest('.js-add-product-to-cart')) {
                var customStickerElement = document.querySelector('.js-custom-sticker-option');
                var isCustomStickerChecked = customStickerElement ? customStickerElement.checked : false;
                var previewContainer = document.querySelector('.js-custom-sticker-product-preview-container');

                if (isCustomStickerChecked && !previewContainer) {
                    event.preventDefault();
                    event.stopPropagation();

                    var openCustomStickerButton = document.querySelector('.js-open-custom-sticker');
                    if (openCustomStickerButton) {
                        _this2.showCustomStickerSidebar({ currentTarget: openCustomStickerButton });
                    }
                }
            }
        }, true);

        options.forEach(function (option) {
            return option.addEventListener('change', EventHandlers.handleCustomStickerSelection);
        });

        if (slideOut) {
            slideOut.addEventListener('click', UIController.closeSidebar);
        }

        closeButtons.forEach(function (button) {
            return button.addEventListener('click', UIController.closeSidebar);
        });
    },
    initializeCustomStickerInputs: function initializeCustomStickerInputs() {
        var inputs = document.querySelectorAll(SELECTORS.inputs.inputs);

        inputs.forEach(function (input) {
            var config = CONFIG[input.dataset.type];

            input.addEventListener('input', function (e) {
                return EventHandlers.handleTextInput(e, config);
            });
        });
    },
    showCustomStickerSidebar: function showCustomStickerSidebar(event) {
        var _this3 = this;

        var _event$currentTarget$ = event.currentTarget.dataset,
            stickerId = _event$currentTarget$.stickerId,
            _event$currentTarget$2 = _event$currentTarget$.productId,
            productId = _event$currentTarget$2 === undefined ? null : _event$currentTarget$2;


        APIService.getCustomSticker(productId, stickerId).then(function (data) {
            if (data.success) {
                if (data.message.hasAnotherCustomStickerInOrder) {
                    document.querySelector(SELECTORS.widgets.main).classList.add('hide');
                    document.querySelector(SELECTORS.preview.wrapper).classList.add('hide');
                    document.querySelector(SELECTORS.widgets.alreadyExists).classList.remove('hide');
                } else {
                    UIController.showSidebar();
                    document.querySelector(SELECTORS.content).innerHTML = data.message.sidebar;
                    _this3.initializeAll();

                    var form = document.querySelector(SELECTORS.form);
                    form.addEventListener('submit', EventHandlers.handleFormSubmit);
                }
            }
        }).catch(function (error) {
            return console.error('Error:', error);
        });
    }
};

CustomStickerApp.init();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImZha2VfZDJlNjFhMi5qcyJdLCJuYW1lcyI6WyJodG1sVG9JbWFnZSIsIkNPTkZJRyIsInRpdGxlIiwibWF4TGluZXMiLCJtYXhMaW5lTGVuZ3RoIiwibWF4VG90YWxMZW5ndGgiLCJtZXNzYWdlIiwiU0VMRUNUT1JTIiwic2lkZWJhciIsInNsaWRlT3V0IiwiYm9keSIsImNhcnRTaWRlYmFyIiwicHJldmlldyIsIndyYXBwZXIiLCJpbWFnZSIsImZvcm0iLCJjb250ZW50Iiwid2lkZ2V0cyIsIm1haW4iLCJhbHJlYWR5RXhpc3RzIiwiY291bnRlcnMiLCJpbnB1dHMiLCJtZXNzYWdlSFRNTCIsInRpdGxlSFRNTCIsIlVJQ29udHJvbGxlciIsInNob3dTaWRlYmFyIiwiZG9jdW1lbnQiLCJxdWVyeVNlbGVjdG9yIiwic3R5bGUiLCJ3aWR0aCIsImNsYXNzTGlzdCIsImFkZCIsImNsb3NlU2lkZWJhciIsImNhcnRTaWRlYmFySXNPcGVuIiwib2Zmc2V0V2lkdGgiLCJyZW1vdmUiLCJwcm9jZXNzVGV4dCIsInRleHQiLCJjb25maWciLCJ3b3JkcyIsInNwbGl0IiwiZmlsdGVyIiwid29yZCIsImxlbmd0aCIsImZvcm1hdHRlZExpbmVzIiwiY3VycmVudExpbmUiLCJpIiwiY3VycmVudFdvcmQiLCJzYWZlV29yZCIsInN1YnN0cmluZyIsInB1c2giLCJsYXN0TGluZVNwYWNlIiwiaiIsIm5leHRXb3JkIiwic2FuaXRpemVJbnB1dCIsInNhbml0aXplZCIsInJlcGxhY2UiLCJ1cGRhdGVQcmV2aWV3IiwidGl0bGVJbnB1dCIsIm1lc3NhZ2VJbnB1dCIsInRpdGxlUHJldmlldyIsIm1lc3NhZ2VQcmV2aWV3IiwicHJvY2Vzc2VkVGl0bGVMaW5lcyIsInZhbHVlIiwiam9pbiIsImlubmVySFRNTCIsInByb2Nlc3NlZE1lc3NhZ2VMaW5lcyIsInVwZGF0ZUNvdW50ZXIiLCJ0eXBlIiwiY291bnRlciIsImxpbmVzIiwidG90YWxMZW5ndGgiLCJsYXN0UGFydExlbmd0aCIsInRleHRDb250ZW50IiwiY29sb3IiLCJ1cGRhdGVDb3VudGVycyIsIkFQSVNlcnZpY2UiLCJnZXRDdXN0b21TdGlja2VyIiwicHJvZHVjdElkIiwic3RpY2tlcklkIiwiZmV0Y2giLCJ0aGVuIiwicmVzcG9uc2UiLCJqc29uIiwic2F2ZUN1c3RvbVN0aWNrZXIiLCJtZXRob2QiLCJmb3JtRGF0YSIsIkV2ZW50SGFuZGxlcnMiLCJoYW5kbGVUZXh0SW5wdXQiLCJldmVudCIsImlucHV0IiwidGFyZ2V0Iiwic2FuaXRpemVkVGV4dCIsInByb2Nlc3NlZExpbmVzIiwicHJvY2Vzc2VkVGV4dCIsInRyaW0iLCJoYW5kbGVDdXN0b21TdGlja2VyU2VsZWN0aW9uIiwicHJldmlld1dyYXBwZXIiLCJjaGVja2VkIiwiY2hpbGRyZW4iLCJDdXN0b21TdGlja2VyQXBwIiwic2hvd0N1c3RvbVN0aWNrZXJTaWRlYmFyIiwiaGFuZGxlRm9ybVN1Ym1pdCIsInByZXZlbnREZWZhdWx0IiwiRm9ybURhdGEiLCJwcmV2aWV3RWxlbWVudCIsInRlbXBJbWFnZSIsImh0bWxUb0ltYWdlQ29uZmlnIiwiY2FjaGVCdXN0IiwibmF2aWdhdG9yIiwidXNlckFnZW50IiwidG9Mb3dlckNhc2UiLCJpbmRleE9mIiwic2tpcEZvbnRzIiwidG9QbmciLCJjdXN0b21TdGlja2VySW1hZ2UiLCJhcHBlbmQiLCJkYXRhIiwic3VjY2VzcyIsInF1ZXJ5U2VsZWN0b3JBbGwiLCJmb3JFYWNoIiwic3JjIiwiY2F0Y2giLCJjb25zb2xlIiwiZXJyb3IiLCJpbml0Iiwid2luZG93IiwiY3VzdG9tU3RpY2tlckluaXRpYWxpemVkIiwiYWRkRXZlbnRMaXN0ZW5lciIsImluaXRpYWxpemVTaWRlYmFyQ29udHJvbHMiLCJvbmNlIiwiaW5pdGlhbGl6ZUFsbCIsImluaXRpYWxpemVDdXN0b21TdGlja2VySW5wdXRzIiwiY2xvc2VCdXR0b25zIiwib3B0aW9ucyIsIm9wZW5CdXR0b24iLCJlIiwiY2xvc2VzdCIsImN1cnJlbnRUYXJnZXQiLCJjdXN0b21TdGlja2VyRWxlbWVudCIsImlzQ3VzdG9tU3RpY2tlckNoZWNrZWQiLCJwcmV2aWV3Q29udGFpbmVyIiwic3RvcFByb3BhZ2F0aW9uIiwib3BlbkN1c3RvbVN0aWNrZXJCdXR0b24iLCJvcHRpb24iLCJidXR0b24iLCJkYXRhc2V0IiwiaGFzQW5vdGhlckN1c3RvbVN0aWNrZXJJbk9yZGVyIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7O0lBQVlBLFc7Ozs7QUFFWixJQUFNQyxTQUFTO0FBQ1hDLFdBQU87QUFDSEMsa0JBQVUsQ0FEUDtBQUVIQyx1QkFBZSxFQUZaO0FBR0gsWUFBSUMsY0FBSixHQUFxQjtBQUFFLG1CQUFPLEtBQUtGLFFBQUwsR0FBZ0IsS0FBS0MsYUFBNUI7QUFBNEM7QUFIaEUsS0FESTtBQU1YRSxhQUFTO0FBQ0xILGtCQUFVLENBREw7QUFFTEMsdUJBQWUsRUFGVjtBQUdMLFlBQUlDLGNBQUosR0FBcUI7QUFBRSxtQkFBTyxLQUFLRixRQUFMLEdBQWdCLEtBQUtDLGFBQTVCO0FBQTRDO0FBSDlEO0FBTkUsQ0FBZjs7QUFhQSxJQUFNRyxZQUFZO0FBQ2RDLGFBQVMsNEJBREs7QUFFZEMsY0FBVSxlQUZJO0FBR2RDLFVBQU0sVUFIUTtBQUlkQyxpQkFBYSxrQkFKQztBQUtkQyxhQUFTO0FBQ0xDLGlCQUFTLHlDQURKO0FBRUxQLGlCQUFTLG9DQUZKO0FBR0xKLGVBQU8sa0NBSEY7QUFJTFksZUFBTztBQUpGLEtBTEs7QUFXZEMsVUFBTSx5QkFYUTtBQVlkQyxhQUFTLDRCQVpLO0FBYWRDLGFBQVM7QUFDTEMsY0FBTSwyQkFERDtBQUVMQyx1QkFBZTtBQUZWLEtBYks7QUFpQmRDLGNBQVU7QUFDTmQsaUJBQVMsb0NBREg7QUFFTkosZUFBTztBQUZELEtBakJJO0FBcUJkbUIsWUFBUTtBQUNKZixpQkFBUyw0QkFETDtBQUVKSixlQUFPLDBCQUZIO0FBR0ptQixnQkFBUSwwQkFISjtBQUlKQyxxQkFBYSx5QkFKVDtBQUtKQyxtQkFBVztBQUxQO0FBckJNLENBQWxCOztBQThCQSxJQUFNQyxlQUFlO0FBQ2pCQyxlQURpQix5QkFDSDtBQUNWLFlBQU1qQixVQUFVa0IsU0FBU0MsYUFBVCxDQUF1QnBCLFVBQVVDLE9BQWpDLENBQWhCO0FBQ0EsWUFBTUMsV0FBV2lCLFNBQVNDLGFBQVQsQ0FBdUJwQixVQUFVRSxRQUFqQyxDQUFqQjtBQUNBLFlBQU1DLE9BQU9nQixTQUFTQyxhQUFULENBQXVCcEIsVUFBVUcsSUFBakMsQ0FBYjs7QUFFQSxZQUFJRixXQUFXQyxRQUFmLEVBQXlCO0FBQ3JCRCxvQkFBUW9CLEtBQVIsQ0FBY0MsS0FBZCxHQUFzQixJQUF0QjtBQUNBcEIscUJBQVNxQixTQUFULENBQW1CQyxHQUFuQixDQUF1QixvQkFBdkI7QUFDQXJCLGlCQUFLb0IsU0FBTCxDQUFlQyxHQUFmLENBQW1CLGlCQUFuQjtBQUNIO0FBQ0osS0FYZ0I7QUFhakJDLGdCQWJpQiwwQkFhRjtBQUNYLFlBQU14QixVQUFVa0IsU0FBU0MsYUFBVCxDQUF1QnBCLFVBQVVDLE9BQWpDLENBQWhCO0FBQ0EsWUFBTUMsV0FBV2lCLFNBQVNDLGFBQVQsQ0FBdUJwQixVQUFVRSxRQUFqQyxDQUFqQjtBQUNBLFlBQU1DLE9BQU9nQixTQUFTQyxhQUFULENBQXVCcEIsVUFBVUcsSUFBakMsQ0FBYjtBQUNBLFlBQU11QixvQkFBb0JQLFNBQVNDLGFBQVQsQ0FBdUJwQixVQUFVSSxXQUFqQyxFQUE4Q3VCLFdBQTlDLEdBQTRELENBQXRGOztBQUVBLFlBQUkxQixRQUFRb0IsS0FBUixDQUFjQyxLQUFkLEtBQXdCLEtBQTVCLEVBQW1DO0FBQy9CckIsb0JBQVFvQixLQUFSLENBQWNDLEtBQWQsR0FBc0IsS0FBdEI7QUFDQSxnQkFBSSxDQUFDSSxpQkFBTCxFQUF3QjtBQUNwQnhCLHlCQUFTcUIsU0FBVCxDQUFtQkssTUFBbkIsQ0FBMEIsb0JBQTFCO0FBQ0F6QixxQkFBS29CLFNBQUwsQ0FBZUssTUFBZixDQUFzQixpQkFBdEI7QUFDSDtBQUNKO0FBQ0osS0ExQmdCO0FBNEJqQkMsZUE1QmlCLHVCQTRCTEMsSUE1QkssRUE0QkNDLE1BNUJELEVBNEJTO0FBQUEsWUFDZm5DLFFBRGUsR0FDWW1DLE1BRFosQ0FDZm5DLFFBRGU7QUFBQSxZQUNMQyxhQURLLEdBQ1lrQyxNQURaLENBQ0xsQyxhQURLOzs7QUFHdEIsWUFBTW1DLFFBQVFGLEtBQUtHLEtBQUwsQ0FBVyxHQUFYLEVBQWdCQyxNQUFoQixDQUF1QjtBQUFBLG1CQUFRQyxLQUFLQyxNQUFMLEdBQWMsQ0FBdEI7QUFBQSxTQUF2QixDQUFkOztBQUVBLFlBQUlDLGlCQUFpQixFQUFyQjtBQUNBLFlBQUlDLGNBQWMsRUFBbEI7O0FBRUEsYUFBSyxJQUFJQyxJQUFJLENBQWIsRUFBZ0JBLElBQUlQLE1BQU1JLE1BQTFCLEVBQWtDRyxHQUFsQyxFQUF1QztBQUNuQyxnQkFBTUMsY0FBY1IsTUFBTU8sQ0FBTixDQUFwQjs7QUFFQSxnQkFBTUUsV0FBV0QsWUFBWUUsU0FBWixDQUFzQixDQUF0QixFQUF5QjdDLGFBQXpCLENBQWpCOztBQUVBLGdCQUFJeUMsWUFBWUYsTUFBWixLQUF1QixDQUEzQixFQUE4QjtBQUMxQkUsOEJBQWNHLFFBQWQ7QUFDSCxhQUZELE1BRU8sSUFBSUgsWUFBWUYsTUFBWixHQUFxQkssU0FBU0wsTUFBOUIsR0FBdUMsQ0FBdkMsSUFBNEN2QyxhQUFoRCxFQUErRDtBQUNsRXlDLCtCQUFlLE1BQU1HLFFBQXJCO0FBQ0gsYUFGTSxNQUVBO0FBQ0hKLCtCQUFlTSxJQUFmLENBQW9CTCxXQUFwQjtBQUNBQSw4QkFBY0csUUFBZDs7QUFFQSxvQkFBSUosZUFBZUQsTUFBZixJQUF5QnhDLFdBQVcsQ0FBeEMsRUFBMkM7O0FBRXZDLHdCQUFJZ0QsZ0JBQWdCL0MsZ0JBQWdCeUMsWUFBWUYsTUFBaEQ7O0FBRUEseUJBQUssSUFBSVMsSUFBSU4sSUFBSSxDQUFqQixFQUFvQk0sSUFBSWIsTUFBTUksTUFBOUIsRUFBc0NTLEdBQXRDLEVBQTJDO0FBQ3ZDLDRCQUFNQyxXQUFXZCxNQUFNYSxDQUFOLENBQWpCOztBQUVBLDRCQUFJRCxpQkFBaUJFLFNBQVNWLE1BQVQsR0FBa0IsQ0FBdkMsRUFBMEM7QUFDdENFLDJDQUFlLE1BQU1RLFFBQXJCO0FBQ0FGLDZDQUFrQkUsU0FBU1YsTUFBVCxHQUFrQixDQUFwQztBQUNILHlCQUhELE1BSUssSUFBSVEsZ0JBQWdCLENBQXBCLEVBQXVCO0FBQ3hCTiwyQ0FBZSxNQUFNUSxTQUFTSixTQUFULENBQW1CLENBQW5CLEVBQXNCRSxnQkFBZ0IsQ0FBdEMsQ0FBckI7QUFDQTtBQUNILHlCQUhJLE1BSUE7QUFDRDtBQUNIO0FBQ0o7QUFDRDtBQUNIO0FBQ0o7QUFDSjs7QUFFRCxZQUFJTixZQUFZRixNQUFaLEdBQXFCLENBQXJCLElBQTBCQyxlQUFlRCxNQUFmLEdBQXdCeEMsUUFBdEQsRUFBZ0U7QUFDNUR5QywyQkFBZU0sSUFBZixDQUFvQkwsV0FBcEI7QUFDSDs7QUFFRCxlQUFPRCxjQUFQO0FBQ0gsS0E5RWdCOzs7QUFnRmpCVSxtQkFBZSx1QkFBQ2pCLElBQUQsRUFBVTtBQUNyQjtBQUNBLFlBQUlrQixZQUFZbEIsS0FBS21CLE9BQUwsQ0FBYSxLQUFiLEVBQW9CLEVBQXBCLENBQWhCO0FBQ0FELG9CQUFZQSxVQUFVQyxPQUFWLENBQWtCLE9BQWxCLEVBQTJCLEdBQTNCLENBQVo7O0FBRUE7QUFDQUQsb0JBQVlBLFVBQVVDLE9BQVYsQ0FBa0IsK0NBQWxCLEVBQW1FLEVBQW5FLENBQVo7O0FBRUE7QUFDQUQsb0JBQVlBLFVBQVVDLE9BQVYsQ0FBa0IsaUhBQWxCLEVBQXFJLEVBQXJJLENBQVo7QUFDQSxlQUFPRCxTQUFQO0FBQ0gsS0EzRmdCOztBQTZGakJFLGlCQTdGaUIsMkJBNkZEO0FBQ1osWUFBTUMsYUFBYWhDLFNBQVNDLGFBQVQsQ0FBdUJwQixVQUFVYyxNQUFWLENBQWlCbkIsS0FBeEMsQ0FBbkI7QUFDQSxZQUFNeUQsZUFBZWpDLFNBQVNDLGFBQVQsQ0FBdUJwQixVQUFVYyxNQUFWLENBQWlCZixPQUF4QyxDQUFyQjtBQUNBLFlBQU1zRCxlQUFlbEMsU0FBU0MsYUFBVCxDQUF1QnBCLFVBQVVLLE9BQVYsQ0FBa0JWLEtBQXpDLENBQXJCO0FBQ0EsWUFBTTJELGlCQUFpQm5DLFNBQVNDLGFBQVQsQ0FBdUJwQixVQUFVSyxPQUFWLENBQWtCTixPQUF6QyxDQUF2QjtBQUNBLFlBQU1pQixZQUFZRyxTQUFTQyxhQUFULENBQXVCcEIsVUFBVWMsTUFBVixDQUFpQkUsU0FBeEMsQ0FBbEI7QUFDQSxZQUFNRCxjQUFjSSxTQUFTQyxhQUFULENBQXVCcEIsVUFBVWMsTUFBVixDQUFpQkMsV0FBeEMsQ0FBcEI7O0FBRUEsWUFBTXdDLHNCQUFzQnRDLGFBQWFZLFdBQWIsQ0FBeUJzQixXQUFXSyxLQUFwQyxFQUEyQzlELE9BQU9DLEtBQWxELEVBQXlEOEQsSUFBekQsQ0FBOEQsUUFBOUQsQ0FBNUI7QUFDQUoscUJBQWFLLFNBQWIsR0FBeUJILG1CQUF6QjtBQUNBdkMsa0JBQVV3QyxLQUFWLEdBQWtCRCxtQkFBbEI7O0FBRUEsWUFBTUksd0JBQXdCMUMsYUFBYVksV0FBYixDQUF5QnVCLGFBQWFJLEtBQXRDLEVBQTZDOUQsT0FBT0ssT0FBcEQsRUFBNkQwRCxJQUE3RCxDQUFrRSxRQUFsRSxDQUE5QjtBQUNBSCx1QkFBZUksU0FBZixHQUEyQkMscUJBQTNCO0FBQ0E1QyxvQkFBWXlDLEtBQVosR0FBb0JHLHFCQUFwQjtBQUNILEtBNUdnQjtBQThHakJDLGlCQTlHaUIseUJBOEdIQyxJQTlHRyxFQThHRztBQUNoQixZQUFNeEQsVUFBVWMsU0FBU0MsYUFBVCxDQUF1QnBCLFVBQVVLLE9BQVYsQ0FBa0J3RCxJQUFsQixDQUF2QixDQUFoQjtBQUNBLFlBQU1DLFVBQVUzQyxTQUFTQyxhQUFULENBQXVCcEIsVUFBVWEsUUFBVixDQUFtQmdELElBQW5CLENBQXZCLENBQWhCO0FBRmdCLDJCQUcwQm5FLE9BQU9tRSxJQUFQLENBSDFCO0FBQUEsWUFHUi9ELGNBSFEsZ0JBR1JBLGNBSFE7QUFBQSxZQUdRRCxhQUhSLGdCQUdRQSxhQUhSOzs7QUFLaEIsWUFBTTJELFFBQVFuRCxRQUFRcUQsU0FBdEI7QUFDQSxZQUFJSyxRQUFRLEVBQVo7QUFDQSxZQUFJQyxjQUFjLENBQWxCOztBQUVBLFlBQUlSLEtBQUosRUFBVztBQUNQTyxvQkFBUVAsTUFBTXZCLEtBQU4sQ0FBWSxjQUFaLENBQVI7QUFDQSxnQkFBTWdDLGlCQUFpQkYsTUFBTTNCLE1BQU4sR0FBZSxDQUFmLEdBQW1CMkIsTUFBTUEsTUFBTTNCLE1BQU4sR0FBZSxDQUFyQixFQUF3QkEsTUFBM0MsR0FBb0QsQ0FBM0U7QUFDQTRCLDBCQUFjLENBQUNELE1BQU0zQixNQUFOLEdBQWUsQ0FBaEIsSUFBcUJ2QyxhQUFyQixHQUFxQ29FLGNBQW5EO0FBQ0g7O0FBRURILGdCQUFRSSxXQUFSLEdBQXlCRixXQUF6QixTQUF3Q2xFLGNBQXhDOztBQUVBLFlBQUlxRSxRQUFRLE1BQVo7QUFDQSxZQUFJSCxlQUFlbEUsY0FBbkIsRUFBbUM7QUFDL0JxRSxvQkFBUSxTQUFSO0FBQ0gsU0FGRCxNQUVPLElBQUlILGVBQWVsRSxpQkFBaUIsR0FBcEMsRUFBeUM7QUFDNUNxRSxvQkFBUSxTQUFSO0FBQ0g7QUFDREwsZ0JBQVF6QyxLQUFSLENBQWM4QyxLQUFkLEdBQXNCQSxLQUF0QjtBQUNILEtBdElnQjtBQXdJakJDLGtCQXhJaUIsNEJBd0lBO0FBQ2IsYUFBS1IsYUFBTCxDQUFtQixTQUFuQjtBQUNBLGFBQUtBLGFBQUwsQ0FBbUIsT0FBbkI7QUFDSDtBQTNJZ0IsQ0FBckI7O0FBOElBLElBQU1TLGFBQWE7QUFDZkMsc0JBQWtCLDBCQUFDQyxTQUFELEVBQVlDLFNBQVo7QUFBQSxlQUNkQyx5Q0FBdUNGLFNBQXZDLG1CQUE4REMsU0FBOUQsRUFDS0UsSUFETCxDQUNVO0FBQUEsbUJBQVlDLFNBQVNDLElBQVQsRUFBWjtBQUFBLFNBRFYsQ0FEYztBQUFBLEtBREg7O0FBS2ZDLHVCQUFtQjtBQUFBLGVBQ2ZKLE1BQU0sc0JBQU4sRUFBOEI7QUFDMUJLLG9CQUFRLE1BRGtCO0FBRTFCM0Usa0JBQU00RTtBQUZvQixTQUE5QixFQUdHTCxJQUhILENBR1E7QUFBQSxtQkFBWUMsU0FBU0MsSUFBVCxFQUFaO0FBQUEsU0FIUixDQURlO0FBQUE7QUFMSixDQUFuQjs7QUFZQSxJQUFNSSxnQkFBZ0I7QUFDbEJDLG1CQURrQiwyQkFDRkMsS0FERSxFQUNLbkQsTUFETCxFQUNhO0FBQzNCLFlBQU1vRCxRQUFRRCxNQUFNRSxNQUFwQjtBQUNBLFlBQUl0RCxPQUFPcUQsTUFBTTNCLEtBQWpCOztBQUVBLFlBQU02QixnQkFBZ0JwRSxhQUFhOEIsYUFBYixDQUEyQmpCLElBQTNCLENBQXRCO0FBQ0EsWUFBSXVELGtCQUFrQnZELElBQXRCLEVBQTRCO0FBQ3hCcUQsa0JBQU0zQixLQUFOLEdBQWM2QixhQUFkO0FBQ0F2RCxtQkFBT3VELGFBQVA7QUFDSDs7QUFFRCxZQUFNQyxpQkFBaUJyRSxhQUFhWSxXQUFiLENBQXlCQyxJQUF6QixFQUErQkMsTUFBL0IsQ0FBdkI7QUFDQSxZQUFNd0QsZ0JBQWdCRCxlQUFlN0IsSUFBZixDQUFvQixHQUFwQixDQUF0Qjs7QUFFQSxZQUFJOEIsY0FBY0MsSUFBZCxPQUF5QjFELEtBQUswRCxJQUFMLEVBQTdCLEVBQTBDO0FBQ3RDTCxrQkFBTTNCLEtBQU4sR0FBYytCLGFBQWQ7QUFDSDs7QUFFRHRFLHFCQUFhaUMsYUFBYjtBQUNBakMscUJBQWFtRCxjQUFiO0FBQ0gsS0FwQmlCO0FBc0JsQnFCLGdDQXRCa0Isd0NBc0JXUCxLQXRCWCxFQXNCa0I7QUFDaEMsWUFBTVEsaUJBQWlCdkUsU0FBU0MsYUFBVCxDQUF1QnBCLFVBQVVLLE9BQVYsQ0FBa0JDLE9BQXpDLENBQXZCOztBQUVBLFlBQUk0RSxNQUFNRSxNQUFOLENBQWFPLE9BQWIsSUFBd0JELGVBQWVFLFFBQWYsQ0FBd0J4RCxNQUF4QixLQUFtQyxDQUEvRCxFQUFrRTtBQUM5RHlELDZCQUFpQkMsd0JBQWpCLENBQTBDWixLQUExQztBQUNIO0FBQ0osS0E1QmlCO0FBOEJsQmEsb0JBOUJrQiw0QkE4QkRiLEtBOUJDLEVBOEJNO0FBQ3BCQSxjQUFNYyxjQUFOO0FBQ0EsWUFBTXhGLE9BQU8wRSxNQUFNRSxNQUFuQjtBQUNBLFlBQU1MLFdBQVcsSUFBSWtCLFFBQUosQ0FBYXpGLElBQWIsQ0FBakI7QUFDQSxZQUFNMEYsaUJBQWlCL0UsU0FBU0MsYUFBVCxDQUF1QiwwQkFBdkIsQ0FBdkI7QUFDQSxZQUFJK0Usa0JBQUo7O0FBRUEsWUFBSUMsb0JBQW9CLEVBQUVDLFdBQVcsSUFBYixFQUF4QjtBQUNBLFlBQUdDLFVBQVVDLFNBQVYsQ0FBb0JDLFdBQXBCLEdBQWtDQyxPQUFsQyxDQUEwQyxTQUExQyxJQUF1RCxDQUFDLENBQTNELEVBQThEO0FBQzFETCxnQ0FBb0IsRUFBRUMsV0FBVyxJQUFiLEVBQW1CSyxXQUFXLElBQTlCLEVBQXBCO0FBQ0g7O0FBRURqSCxvQkFBWWtILEtBQVosQ0FBa0JULGNBQWxCLEVBQWtDRSxpQkFBbEMsRUFDSzFCLElBREwsQ0FDVSw4QkFBc0I7QUFDeEJ5Qix3QkFBWVMsa0JBQVo7QUFDQTdCLHFCQUFTOEIsTUFBVCxDQUFnQix1QkFBaEIsRUFBeUNELGtCQUF6QztBQUNBLG1CQUFPdkMsV0FBV1EsaUJBQVgsQ0FBNkJFLFFBQTdCLENBQVA7QUFDSCxTQUxMLEVBTUtMLElBTkwsQ0FNVSxnQkFBUTtBQUNWLGdCQUFJb0MsS0FBS0MsT0FBVCxFQUFrQjtBQUNkOUYsNkJBQWFRLFlBQWI7QUFDQU4seUJBQVM2RixnQkFBVCxDQUEwQmhILFVBQVVLLE9BQVYsQ0FBa0JFLEtBQTVDLEVBQ0swRyxPQURMLENBQ2E7QUFBQSwyQkFBUzFHLE1BQU0yRyxHQUFOLEdBQVlmLFNBQXJCO0FBQUEsaUJBRGI7QUFFQWhGLHlCQUFTQyxhQUFULENBQXVCcEIsVUFBVUssT0FBVixDQUFrQkMsT0FBekMsRUFBa0RvRCxTQUFsRCxHQUE4RG9ELEtBQUsvRyxPQUFMLENBQWFNLE9BQTNFO0FBQ0g7QUFDSixTQWJMLEVBY0s4RyxLQWRMLENBY1c7QUFBQSxtQkFBU0MsUUFBUUMsS0FBUixDQUFjLFFBQWQsRUFBd0JBLEtBQXhCLENBQVQ7QUFBQSxTQWRYO0FBZUg7QUF6RGlCLENBQXRCOztBQTRETyxJQUFNeEIsOENBQW1CO0FBQzVCeUIsUUFENEIsa0JBQ3JCO0FBQUE7O0FBQ0gsWUFBSSxDQUFDQyxPQUFPQyx3QkFBWixFQUFzQztBQUNsQ3JHLHFCQUFTc0csZ0JBQVQsQ0FBMEIsa0JBQTFCLEVBQThDO0FBQUEsdUJBQU0sTUFBS0MseUJBQUwsRUFBTjtBQUFBLGFBQTlDLEVBQXNGLEVBQUNDLE1BQU0sSUFBUCxFQUF0RjtBQUNBSixtQkFBT0Msd0JBQVAsR0FBa0MsSUFBbEM7QUFDSDtBQUNKLEtBTjJCO0FBUTVCSSxpQkFSNEIsMkJBUVo7QUFDWixhQUFLQyw2QkFBTDtBQUNBNUcscUJBQWFpQyxhQUFiO0FBQ0FqQyxxQkFBYW1ELGNBQWI7QUFDSCxLQVoyQjtBQWM1QnNELDZCQWQ0Qix1Q0FjQTtBQUFBOztBQUN4QixZQUFNSSxlQUFlM0csU0FBUzZGLGdCQUFULENBQTBCLGtDQUExQixDQUFyQjtBQUNBLFlBQU1lLFVBQVU1RyxTQUFTNkYsZ0JBQVQsQ0FBMEIsMkJBQTFCLENBQWhCO0FBQ0EsWUFBTTlHLFdBQVdpQixTQUFTQyxhQUFULENBQXVCcEIsVUFBVUUsUUFBakMsQ0FBakI7O0FBRUFpQixpQkFBU2hCLElBQVQsQ0FBY3NILGdCQUFkLENBQStCLE9BQS9CLEVBQXdDLGFBQUs7QUFDekMsZ0JBQU1PLGFBQWFDLEVBQUU3QyxNQUFGLENBQVM4QyxPQUFULENBQWlCLHlCQUFqQixDQUFuQjtBQUNBLGdCQUFJRixVQUFKLEVBQWdCO0FBQ1osdUJBQUtsQyx3QkFBTCxDQUE4QixFQUFDcUMsZUFBZUgsVUFBaEIsRUFBOUI7QUFDSDtBQUNKLFNBTEQ7O0FBT0E7QUFDQTdHLGlCQUFTc0csZ0JBQVQsQ0FBMEIsT0FBMUIsRUFBbUMsVUFBQ3ZDLEtBQUQsRUFBVztBQUMxQyxnQkFBSUEsTUFBTUUsTUFBTixDQUFhOEMsT0FBYixDQUFxQix5QkFBckIsQ0FBSixFQUFxRDtBQUNqRCxvQkFBTUUsdUJBQXVCakgsU0FBU0MsYUFBVCxDQUF1QiwyQkFBdkIsQ0FBN0I7QUFDQSxvQkFBTWlILHlCQUF5QkQsdUJBQXVCQSxxQkFBcUJ6QyxPQUE1QyxHQUFzRCxLQUFyRjtBQUNBLG9CQUFNMkMsbUJBQW1CbkgsU0FBU0MsYUFBVCxDQUF1Qiw4Q0FBdkIsQ0FBekI7O0FBRUEsb0JBQUlpSCwwQkFBMEIsQ0FBQ0MsZ0JBQS9CLEVBQWlEO0FBQzdDcEQsMEJBQU1jLGNBQU47QUFDQWQsMEJBQU1xRCxlQUFOOztBQUVBLHdCQUFNQywwQkFBMEJySCxTQUFTQyxhQUFULENBQXVCLHlCQUF2QixDQUFoQztBQUNBLHdCQUFJb0gsdUJBQUosRUFBNkI7QUFDekIsK0JBQUsxQyx3QkFBTCxDQUE4QixFQUFDcUMsZUFBZUssdUJBQWhCLEVBQTlCO0FBQ0g7QUFDSjtBQUNKO0FBQ0osU0FoQkQsRUFnQkcsSUFoQkg7O0FBa0JBVCxnQkFBUWQsT0FBUixDQUFnQjtBQUFBLG1CQUNad0IsT0FBT2hCLGdCQUFQLENBQXdCLFFBQXhCLEVBQWtDekMsY0FBY1MsNEJBQWhELENBRFk7QUFBQSxTQUFoQjs7QUFJQSxZQUFJdkYsUUFBSixFQUFjO0FBQ1ZBLHFCQUFTdUgsZ0JBQVQsQ0FBMEIsT0FBMUIsRUFBbUN4RyxhQUFhUSxZQUFoRDtBQUNIOztBQUVEcUcscUJBQWFiLE9BQWIsQ0FBcUI7QUFBQSxtQkFDakJ5QixPQUFPakIsZ0JBQVAsQ0FBd0IsT0FBeEIsRUFBaUN4RyxhQUFhUSxZQUE5QyxDQURpQjtBQUFBLFNBQXJCO0FBR0gsS0F4RDJCO0FBMEQ1Qm9HLGlDQTFENEIsMkNBMERJO0FBQzVCLFlBQU0vRyxTQUFTSyxTQUFTNkYsZ0JBQVQsQ0FBMEJoSCxVQUFVYyxNQUFWLENBQWlCQSxNQUEzQyxDQUFmOztBQUVBQSxlQUFPbUcsT0FBUCxDQUFlLGlCQUFTO0FBQ3BCLGdCQUFNbEYsU0FBU3JDLE9BQU95RixNQUFNd0QsT0FBTixDQUFjOUUsSUFBckIsQ0FBZjs7QUFFQXNCLGtCQUFNc0MsZ0JBQU4sQ0FBdUIsT0FBdkIsRUFBZ0M7QUFBQSx1QkFDNUJ6QyxjQUFjQyxlQUFkLENBQThCZ0QsQ0FBOUIsRUFBaUNsRyxNQUFqQyxDQUQ0QjtBQUFBLGFBQWhDO0FBR0gsU0FORDtBQU9ILEtBcEUyQjtBQXNFNUIrRCw0QkF0RTRCLG9DQXNFSFosS0F0RUcsRUFzRUk7QUFBQTs7QUFBQSxvQ0FDWUEsTUFBTWlELGFBQU4sQ0FBb0JRLE9BRGhDO0FBQUEsWUFDcEJuRSxTQURvQix5QkFDcEJBLFNBRG9CO0FBQUEsMkRBQ1RELFNBRFM7QUFBQSxZQUNUQSxTQURTLDBDQUNHLElBREg7OztBQUc1QkYsbUJBQVdDLGdCQUFYLENBQTRCQyxTQUE1QixFQUF1Q0MsU0FBdkMsRUFDS0UsSUFETCxDQUNVLGdCQUFRO0FBQ1YsZ0JBQUlvQyxLQUFLQyxPQUFULEVBQWtCO0FBQ2Qsb0JBQUlELEtBQUsvRyxPQUFMLENBQWE2SSw4QkFBakIsRUFBaUQ7QUFDN0N6SCw2QkFBU0MsYUFBVCxDQUF1QnBCLFVBQVVVLE9BQVYsQ0FBa0JDLElBQXpDLEVBQStDWSxTQUEvQyxDQUF5REMsR0FBekQsQ0FBNkQsTUFBN0Q7QUFDQUwsNkJBQVNDLGFBQVQsQ0FBdUJwQixVQUFVSyxPQUFWLENBQWtCQyxPQUF6QyxFQUFrRGlCLFNBQWxELENBQTREQyxHQUE1RCxDQUFnRSxNQUFoRTtBQUNBTCw2QkFBU0MsYUFBVCxDQUF1QnBCLFVBQVVVLE9BQVYsQ0FBa0JFLGFBQXpDLEVBQXdEVyxTQUF4RCxDQUFrRUssTUFBbEUsQ0FBeUUsTUFBekU7QUFDSCxpQkFKRCxNQUlPO0FBQ0hYLGlDQUFhQyxXQUFiO0FBQ0FDLDZCQUFTQyxhQUFULENBQXVCcEIsVUFBVVMsT0FBakMsRUFBMENpRCxTQUExQyxHQUFzRG9ELEtBQUsvRyxPQUFMLENBQWFFLE9BQW5FO0FBQ0EsMkJBQUsySCxhQUFMOztBQUVBLHdCQUFNcEgsT0FBT1csU0FBU0MsYUFBVCxDQUF1QnBCLFVBQVVRLElBQWpDLENBQWI7QUFDQUEseUJBQUtpSCxnQkFBTCxDQUFzQixRQUF0QixFQUFnQ3pDLGNBQWNlLGdCQUE5QztBQUNIO0FBQ0o7QUFDSixTQWhCTCxFQWlCS29CLEtBakJMLENBaUJXO0FBQUEsbUJBQVNDLFFBQVFDLEtBQVIsQ0FBYyxRQUFkLEVBQXdCQSxLQUF4QixDQUFUO0FBQUEsU0FqQlg7QUFrQkg7QUEzRjJCLENBQXpCOztBQThGUHhCLGlCQUFpQnlCLElBQWpCIiwiZmlsZSI6ImZha2VfZDJlNjFhMi5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCAqIGFzIGh0bWxUb0ltYWdlIGZyb20gJ2h0bWwtdG8taW1hZ2UnO1xyXG5cclxuY29uc3QgQ09ORklHID0ge1xyXG4gICAgdGl0bGU6IHtcclxuICAgICAgICBtYXhMaW5lczogMyxcclxuICAgICAgICBtYXhMaW5lTGVuZ3RoOiAxMyxcclxuICAgICAgICBnZXQgbWF4VG90YWxMZW5ndGgoKSB7IHJldHVybiB0aGlzLm1heExpbmVzICogdGhpcy5tYXhMaW5lTGVuZ3RoOyB9XHJcbiAgICB9LFxyXG4gICAgbWVzc2FnZToge1xyXG4gICAgICAgIG1heExpbmVzOiAyLFxyXG4gICAgICAgIG1heExpbmVMZW5ndGg6IDMyLFxyXG4gICAgICAgIGdldCBtYXhUb3RhbExlbmd0aCgpIHsgcmV0dXJuIHRoaXMubWF4TGluZXMgKiB0aGlzLm1heExpbmVMZW5ndGg7IH1cclxuICAgIH1cclxufTtcclxuXHJcbmNvbnN0IFNFTEVDVE9SUyA9IHtcclxuICAgIHNpZGViYXI6ICcuanMtY3VzdG9tLXN0aWNrZXItc2lkZWJhcicsXHJcbiAgICBzbGlkZU91dDogJy5qcy1zbGlkZS1vdXQnLFxyXG4gICAgYm9keTogJy5qcy1ib2R5JyxcclxuICAgIGNhcnRTaWRlYmFyOiAnLmpzLWNhcnQtc2lkZWJhcicsXHJcbiAgICBwcmV2aWV3OiB7XHJcbiAgICAgICAgd3JhcHBlcjogJy5qcy1jdXN0b20tc3RpY2tlci1wcm9kdWN0LXBhZ2UtcHJldmlldycsXHJcbiAgICAgICAgbWVzc2FnZTogJy5qcy1jdXN0b20tc3RpY2tlci1tZXNzYWdlLXByZXZpZXcnLFxyXG4gICAgICAgIHRpdGxlOiAnLmpzLWN1c3RvbS1zdGlja2VyLXRpdGxlLXByZXZpZXcnLFxyXG4gICAgICAgIGltYWdlOiAnLmN1c3RvbS1zdGlja2VyLXByZXZpZXdfX2ltYWdlJ1xyXG4gICAgfSxcclxuICAgIGZvcm06ICcuanMtY3VzdG9tLXN0aWNrZXItZm9ybScsXHJcbiAgICBjb250ZW50OiAnLmpzLWN1c3RvbS1zdGlja2VyLWNvbnRlbnQnLFxyXG4gICAgd2lkZ2V0czoge1xyXG4gICAgICAgIG1haW46ICcuanMtY3VzdG9tLXN0aWNrZXItd2lkZ2V0JyxcclxuICAgICAgICBhbHJlYWR5RXhpc3RzOiAnLmpzLWN1c3RvbS1zdGlja2VyLWFscmVhZHknXHJcbiAgICB9LFxyXG4gICAgY291bnRlcnM6IHtcclxuICAgICAgICBtZXNzYWdlOiAnLmpzLWN1c3RvbS1zdGlja2VyLW1lc3NhZ2UtY291bnRlcicsXHJcbiAgICAgICAgdGl0bGU6ICcuanMtY3VzdG9tLXN0aWNrZXItdGl0bGUtY291bnRlcidcclxuICAgIH0sXHJcbiAgICBpbnB1dHM6IHtcclxuICAgICAgICBtZXNzYWdlOiAnLmpzLWN1c3RvbS1zdGlja2VyLW1lc3NhZ2UnLFxyXG4gICAgICAgIHRpdGxlOiAnLmpzLWN1c3RvbS1zdGlja2VyLXRpdGxlJyxcclxuICAgICAgICBpbnB1dHM6ICcuanMtY3VzdG9tLXN0aWNrZXItaW5wdXQnLFxyXG4gICAgICAgIG1lc3NhZ2VIVE1MOiAnLmpzLWN1c3RvbS1tZXNzYWdlLWh0bWwnLFxyXG4gICAgICAgIHRpdGxlSFRNTDogJy5qcy1jdXN0b20tdGl0bGUtaHRtbCdcclxuICAgIH1cclxufTtcclxuXHJcbmNvbnN0IFVJQ29udHJvbGxlciA9IHtcclxuICAgIHNob3dTaWRlYmFyKCkge1xyXG4gICAgICAgIGNvbnN0IHNpZGViYXIgPSBkb2N1bWVudC5xdWVyeVNlbGVjdG9yKFNFTEVDVE9SUy5zaWRlYmFyKTtcclxuICAgICAgICBjb25zdCBzbGlkZU91dCA9IGRvY3VtZW50LnF1ZXJ5U2VsZWN0b3IoU0VMRUNUT1JTLnNsaWRlT3V0KTtcclxuICAgICAgICBjb25zdCBib2R5ID0gZG9jdW1lbnQucXVlcnlTZWxlY3RvcihTRUxFQ1RPUlMuYm9keSk7XHJcblxyXG4gICAgICAgIGlmIChzaWRlYmFyICYmIHNsaWRlT3V0KSB7XHJcbiAgICAgICAgICAgIHNpZGViYXIuc3R5bGUud2lkdGggPSBudWxsO1xyXG4gICAgICAgICAgICBzbGlkZU91dC5jbGFzc0xpc3QuYWRkKCdzbGlkZS1vdXQtLWlzLW9wZW4nKTtcclxuICAgICAgICAgICAgYm9keS5jbGFzc0xpc3QuYWRkKCdvdmVyZmxvdy1oaWRkZW4nKTtcclxuICAgICAgICB9XHJcbiAgICB9LFxyXG5cclxuICAgIGNsb3NlU2lkZWJhcigpIHtcclxuICAgICAgICBjb25zdCBzaWRlYmFyID0gZG9jdW1lbnQucXVlcnlTZWxlY3RvcihTRUxFQ1RPUlMuc2lkZWJhcik7XHJcbiAgICAgICAgY29uc3Qgc2xpZGVPdXQgPSBkb2N1bWVudC5xdWVyeVNlbGVjdG9yKFNFTEVDVE9SUy5zbGlkZU91dCk7XHJcbiAgICAgICAgY29uc3QgYm9keSA9IGRvY3VtZW50LnF1ZXJ5U2VsZWN0b3IoU0VMRUNUT1JTLmJvZHkpO1xyXG4gICAgICAgIGNvbnN0IGNhcnRTaWRlYmFySXNPcGVuID0gZG9jdW1lbnQucXVlcnlTZWxlY3RvcihTRUxFQ1RPUlMuY2FydFNpZGViYXIpLm9mZnNldFdpZHRoID4gMDtcclxuXHJcbiAgICAgICAgaWYgKHNpZGViYXIuc3R5bGUud2lkdGggIT09ICcwcHgnKSB7XHJcbiAgICAgICAgICAgIHNpZGViYXIuc3R5bGUud2lkdGggPSAnMHB4JztcclxuICAgICAgICAgICAgaWYgKCFjYXJ0U2lkZWJhcklzT3Blbikge1xyXG4gICAgICAgICAgICAgICAgc2xpZGVPdXQuY2xhc3NMaXN0LnJlbW92ZSgnc2xpZGUtb3V0LS1pcy1vcGVuJyk7XHJcbiAgICAgICAgICAgICAgICBib2R5LmNsYXNzTGlzdC5yZW1vdmUoJ292ZXJmbG93LWhpZGRlbicpO1xyXG4gICAgICAgICAgICB9XHJcbiAgICAgICAgfVxyXG4gICAgfSxcclxuXHJcbiAgICBwcm9jZXNzVGV4dCh0ZXh0LCBjb25maWcpIHtcclxuICAgICAgICBjb25zdCB7bWF4TGluZXMsIG1heExpbmVMZW5ndGh9ID0gY29uZmlnO1xyXG5cclxuICAgICAgICBjb25zdCB3b3JkcyA9IHRleHQuc3BsaXQoJyAnKS5maWx0ZXIod29yZCA9PiB3b3JkLmxlbmd0aCA+IDApO1xyXG5cclxuICAgICAgICBsZXQgZm9ybWF0dGVkTGluZXMgPSBbXTtcclxuICAgICAgICBsZXQgY3VycmVudExpbmUgPSAnJztcclxuXHJcbiAgICAgICAgZm9yIChsZXQgaSA9IDA7IGkgPCB3b3Jkcy5sZW5ndGg7IGkrKykge1xyXG4gICAgICAgICAgICBjb25zdCBjdXJyZW50V29yZCA9IHdvcmRzW2ldO1xyXG5cclxuICAgICAgICAgICAgY29uc3Qgc2FmZVdvcmQgPSBjdXJyZW50V29yZC5zdWJzdHJpbmcoMCwgbWF4TGluZUxlbmd0aCk7XHJcblxyXG4gICAgICAgICAgICBpZiAoY3VycmVudExpbmUubGVuZ3RoID09PSAwKSB7XHJcbiAgICAgICAgICAgICAgICBjdXJyZW50TGluZSA9IHNhZmVXb3JkO1xyXG4gICAgICAgICAgICB9IGVsc2UgaWYgKGN1cnJlbnRMaW5lLmxlbmd0aCArIHNhZmVXb3JkLmxlbmd0aCArIDEgPD0gbWF4TGluZUxlbmd0aCkge1xyXG4gICAgICAgICAgICAgICAgY3VycmVudExpbmUgKz0gJyAnICsgc2FmZVdvcmQ7XHJcbiAgICAgICAgICAgIH0gZWxzZSB7XHJcbiAgICAgICAgICAgICAgICBmb3JtYXR0ZWRMaW5lcy5wdXNoKGN1cnJlbnRMaW5lKTtcclxuICAgICAgICAgICAgICAgIGN1cnJlbnRMaW5lID0gc2FmZVdvcmQ7XHJcblxyXG4gICAgICAgICAgICAgICAgaWYgKGZvcm1hdHRlZExpbmVzLmxlbmd0aCA+PSBtYXhMaW5lcyAtIDEpIHtcclxuXHJcbiAgICAgICAgICAgICAgICAgICAgbGV0IGxhc3RMaW5lU3BhY2UgPSBtYXhMaW5lTGVuZ3RoIC0gY3VycmVudExpbmUubGVuZ3RoO1xyXG5cclxuICAgICAgICAgICAgICAgICAgICBmb3IgKGxldCBqID0gaSArIDE7IGogPCB3b3Jkcy5sZW5ndGg7IGorKykge1xyXG4gICAgICAgICAgICAgICAgICAgICAgICBjb25zdCBuZXh0V29yZCA9IHdvcmRzW2pdO1xyXG5cclxuICAgICAgICAgICAgICAgICAgICAgICAgaWYgKGxhc3RMaW5lU3BhY2UgPj0gbmV4dFdvcmQubGVuZ3RoICsgMSkge1xyXG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgY3VycmVudExpbmUgKz0gJyAnICsgbmV4dFdvcmQ7XHJcbiAgICAgICAgICAgICAgICAgICAgICAgICAgICBsYXN0TGluZVNwYWNlIC09IChuZXh0V29yZC5sZW5ndGggKyAxKTtcclxuICAgICAgICAgICAgICAgICAgICAgICAgfVxyXG4gICAgICAgICAgICAgICAgICAgICAgICBlbHNlIGlmIChsYXN0TGluZVNwYWNlID4gMSkge1xyXG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgY3VycmVudExpbmUgKz0gJyAnICsgbmV4dFdvcmQuc3Vic3RyaW5nKDAsIGxhc3RMaW5lU3BhY2UgLSAxKTtcclxuICAgICAgICAgICAgICAgICAgICAgICAgICAgIGJyZWFrO1xyXG4gICAgICAgICAgICAgICAgICAgICAgICB9XHJcbiAgICAgICAgICAgICAgICAgICAgICAgIGVsc2Uge1xyXG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgYnJlYWs7XHJcbiAgICAgICAgICAgICAgICAgICAgICAgIH1cclxuICAgICAgICAgICAgICAgICAgICB9XHJcbiAgICAgICAgICAgICAgICAgICAgYnJlYWs7XHJcbiAgICAgICAgICAgICAgICB9XHJcbiAgICAgICAgICAgIH1cclxuICAgICAgICB9XHJcblxyXG4gICAgICAgIGlmIChjdXJyZW50TGluZS5sZW5ndGggPiAwICYmIGZvcm1hdHRlZExpbmVzLmxlbmd0aCA8IG1heExpbmVzKSB7XHJcbiAgICAgICAgICAgIGZvcm1hdHRlZExpbmVzLnB1c2goY3VycmVudExpbmUpO1xyXG4gICAgICAgIH1cclxuXHJcbiAgICAgICAgcmV0dXJuIGZvcm1hdHRlZExpbmVzO1xyXG4gICAgfSxcclxuXHJcbiAgICBzYW5pdGl6ZUlucHV0OiAodGV4dCkgPT4ge1xyXG4gICAgICAgIC8vIFByb2hpYml0IHBpcGVzXHJcbiAgICAgICAgbGV0IHNhbml0aXplZCA9IHRleHQucmVwbGFjZSgvXFx8L2csICcnKTtcclxuICAgICAgICBzYW5pdGl6ZWQgPSBzYW5pdGl6ZWQucmVwbGFjZSgvW8K0YF0vZywgXCInXCIpO1xyXG5cclxuICAgICAgICAvLyBQcm9oaWJpdCBub24gbGF0aW4gY2FyYWN0ZXJcclxuICAgICAgICBzYW5pdGl6ZWQgPSBzYW5pdGl6ZWQucmVwbGFjZSgvW15BLVphLXrDgC3DlsOYLcO2w7gtw7/EgC3Fv8aALcmPMC05XFxzLiw7OiE/J+KAmVwiKClcXC3igJPigJRdL2csICcnKTtcclxuXHJcbiAgICAgICAgLy8gUHJvaGliaXQgZW1vamlzXHJcbiAgICAgICAgc2FuaXRpemVkID0gc2FuaXRpemVkLnJlcGxhY2UoLyhcXHUwMGE5fFxcdTAwYWV8W1xcdTIwMDAtXFx1MjAxOFxcdTIwMUEtXFx1MzMwMF18XFx1ZDgzY1tcXHVkMDAwLVxcdWRmZmZdfFxcdWQ4M2RbXFx1ZDAwMC1cXHVkZmZmXXxcXHVkODNlW1xcdWQwMDAtXFx1ZGZmZl0pL2csICcnKTtcclxuICAgICAgICByZXR1cm4gc2FuaXRpemVkO1xyXG4gICAgfSxcclxuXHJcbiAgICB1cGRhdGVQcmV2aWV3KCkge1xyXG4gICAgICAgIGNvbnN0IHRpdGxlSW5wdXQgPSBkb2N1bWVudC5xdWVyeVNlbGVjdG9yKFNFTEVDVE9SUy5pbnB1dHMudGl0bGUpO1xyXG4gICAgICAgIGNvbnN0IG1lc3NhZ2VJbnB1dCA9IGRvY3VtZW50LnF1ZXJ5U2VsZWN0b3IoU0VMRUNUT1JTLmlucHV0cy5tZXNzYWdlKTtcclxuICAgICAgICBjb25zdCB0aXRsZVByZXZpZXcgPSBkb2N1bWVudC5xdWVyeVNlbGVjdG9yKFNFTEVDVE9SUy5wcmV2aWV3LnRpdGxlKTtcclxuICAgICAgICBjb25zdCBtZXNzYWdlUHJldmlldyA9IGRvY3VtZW50LnF1ZXJ5U2VsZWN0b3IoU0VMRUNUT1JTLnByZXZpZXcubWVzc2FnZSk7XHJcbiAgICAgICAgY29uc3QgdGl0bGVIVE1MID0gZG9jdW1lbnQucXVlcnlTZWxlY3RvcihTRUxFQ1RPUlMuaW5wdXRzLnRpdGxlSFRNTCk7XHJcbiAgICAgICAgY29uc3QgbWVzc2FnZUhUTUwgPSBkb2N1bWVudC5xdWVyeVNlbGVjdG9yKFNFTEVDVE9SUy5pbnB1dHMubWVzc2FnZUhUTUwpO1xyXG5cclxuICAgICAgICBjb25zdCBwcm9jZXNzZWRUaXRsZUxpbmVzID0gVUlDb250cm9sbGVyLnByb2Nlc3NUZXh0KHRpdGxlSW5wdXQudmFsdWUsIENPTkZJRy50aXRsZSkuam9pbignPGJyIC8+Jyk7XHJcbiAgICAgICAgdGl0bGVQcmV2aWV3LmlubmVySFRNTCA9IHByb2Nlc3NlZFRpdGxlTGluZXM7XHJcbiAgICAgICAgdGl0bGVIVE1MLnZhbHVlID0gcHJvY2Vzc2VkVGl0bGVMaW5lcztcclxuXHJcbiAgICAgICAgY29uc3QgcHJvY2Vzc2VkTWVzc2FnZUxpbmVzID0gVUlDb250cm9sbGVyLnByb2Nlc3NUZXh0KG1lc3NhZ2VJbnB1dC52YWx1ZSwgQ09ORklHLm1lc3NhZ2UpLmpvaW4oJzxiciAvPicpO1xyXG4gICAgICAgIG1lc3NhZ2VQcmV2aWV3LmlubmVySFRNTCA9IHByb2Nlc3NlZE1lc3NhZ2VMaW5lcztcclxuICAgICAgICBtZXNzYWdlSFRNTC52YWx1ZSA9IHByb2Nlc3NlZE1lc3NhZ2VMaW5lcztcclxuICAgIH0sXHJcblxyXG4gICAgdXBkYXRlQ291bnRlcih0eXBlKSB7XHJcbiAgICAgICAgY29uc3QgcHJldmlldyA9IGRvY3VtZW50LnF1ZXJ5U2VsZWN0b3IoU0VMRUNUT1JTLnByZXZpZXdbdHlwZV0pO1xyXG4gICAgICAgIGNvbnN0IGNvdW50ZXIgPSBkb2N1bWVudC5xdWVyeVNlbGVjdG9yKFNFTEVDVE9SUy5jb3VudGVyc1t0eXBlXSk7XHJcbiAgICAgICAgY29uc3QgeyBtYXhUb3RhbExlbmd0aCwgbWF4TGluZUxlbmd0aCB9ID0gQ09ORklHW3R5cGVdO1xyXG5cclxuICAgICAgICBjb25zdCB2YWx1ZSA9IHByZXZpZXcuaW5uZXJIVE1MO1xyXG4gICAgICAgIGxldCBsaW5lcyA9IFtdO1xyXG4gICAgICAgIGxldCB0b3RhbExlbmd0aCA9IDA7XHJcblxyXG4gICAgICAgIGlmICh2YWx1ZSkge1xyXG4gICAgICAgICAgICBsaW5lcyA9IHZhbHVlLnNwbGl0KC88YnJcXHMqXFwvPz4vZ2kpO1xyXG4gICAgICAgICAgICBjb25zdCBsYXN0UGFydExlbmd0aCA9IGxpbmVzLmxlbmd0aCA+IDAgPyBsaW5lc1tsaW5lcy5sZW5ndGggLSAxXS5sZW5ndGggOiAwO1xyXG4gICAgICAgICAgICB0b3RhbExlbmd0aCA9IChsaW5lcy5sZW5ndGggLSAxKSAqIG1heExpbmVMZW5ndGggKyBsYXN0UGFydExlbmd0aDtcclxuICAgICAgICB9XHJcblxyXG4gICAgICAgIGNvdW50ZXIudGV4dENvbnRlbnQgPSBgJHt0b3RhbExlbmd0aH0vJHttYXhUb3RhbExlbmd0aH1gO1xyXG5cclxuICAgICAgICBsZXQgY29sb3IgPSAnIzY2Nic7XHJcbiAgICAgICAgaWYgKHRvdGFsTGVuZ3RoID49IG1heFRvdGFsTGVuZ3RoKSB7XHJcbiAgICAgICAgICAgIGNvbG9yID0gJyNmZjAwMDAnO1xyXG4gICAgICAgIH0gZWxzZSBpZiAodG90YWxMZW5ndGggPj0gbWF4VG90YWxMZW5ndGggKiAwLjcpIHtcclxuICAgICAgICAgICAgY29sb3IgPSAnI2ZmOTkwMCc7XHJcbiAgICAgICAgfVxyXG4gICAgICAgIGNvdW50ZXIuc3R5bGUuY29sb3IgPSBjb2xvcjtcclxuICAgIH0sXHJcblxyXG4gICAgdXBkYXRlQ291bnRlcnMoKSB7XHJcbiAgICAgICAgdGhpcy51cGRhdGVDb3VudGVyKCdtZXNzYWdlJyk7XHJcbiAgICAgICAgdGhpcy51cGRhdGVDb3VudGVyKCd0aXRsZScpO1xyXG4gICAgfVxyXG59O1xyXG5cclxuY29uc3QgQVBJU2VydmljZSA9IHtcclxuICAgIGdldEN1c3RvbVN0aWNrZXI6IChwcm9kdWN0SWQsIHN0aWNrZXJJZCkgPT5cclxuICAgICAgICBmZXRjaChgL2dldC1jdXN0b20tc3RpY2tlcj9wcm9kdWN0SWQ9JHtwcm9kdWN0SWR9JnN0aWNrZXJJZD0ke3N0aWNrZXJJZH1gKVxyXG4gICAgICAgICAgICAudGhlbihyZXNwb25zZSA9PiByZXNwb25zZS5qc29uKCkpLFxyXG5cclxuICAgIHNhdmVDdXN0b21TdGlja2VyOiBmb3JtRGF0YSA9PlxyXG4gICAgICAgIGZldGNoKCcvc2F2ZS1jdXN0b20tc3RpY2tlcicsIHtcclxuICAgICAgICAgICAgbWV0aG9kOiAnUE9TVCcsXHJcbiAgICAgICAgICAgIGJvZHk6IGZvcm1EYXRhXHJcbiAgICAgICAgfSkudGhlbihyZXNwb25zZSA9PiByZXNwb25zZS5qc29uKCkpXHJcbn07XHJcblxyXG5jb25zdCBFdmVudEhhbmRsZXJzID0ge1xyXG4gICAgaGFuZGxlVGV4dElucHV0KGV2ZW50LCBjb25maWcpIHtcclxuICAgICAgICBjb25zdCBpbnB1dCA9IGV2ZW50LnRhcmdldDtcclxuICAgICAgICBsZXQgdGV4dCA9IGlucHV0LnZhbHVlO1xyXG5cclxuICAgICAgICBjb25zdCBzYW5pdGl6ZWRUZXh0ID0gVUlDb250cm9sbGVyLnNhbml0aXplSW5wdXQodGV4dCk7XHJcbiAgICAgICAgaWYgKHNhbml0aXplZFRleHQgIT09IHRleHQpIHtcclxuICAgICAgICAgICAgaW5wdXQudmFsdWUgPSBzYW5pdGl6ZWRUZXh0O1xyXG4gICAgICAgICAgICB0ZXh0ID0gc2FuaXRpemVkVGV4dDtcclxuICAgICAgICB9XHJcblxyXG4gICAgICAgIGNvbnN0IHByb2Nlc3NlZExpbmVzID0gVUlDb250cm9sbGVyLnByb2Nlc3NUZXh0KHRleHQsIGNvbmZpZyk7XHJcbiAgICAgICAgY29uc3QgcHJvY2Vzc2VkVGV4dCA9IHByb2Nlc3NlZExpbmVzLmpvaW4oJyAnKTtcclxuXHJcbiAgICAgICAgaWYgKHByb2Nlc3NlZFRleHQudHJpbSgpICE9PSB0ZXh0LnRyaW0oKSkge1xyXG4gICAgICAgICAgICBpbnB1dC52YWx1ZSA9IHByb2Nlc3NlZFRleHQ7XHJcbiAgICAgICAgfVxyXG5cclxuICAgICAgICBVSUNvbnRyb2xsZXIudXBkYXRlUHJldmlldygpO1xyXG4gICAgICAgIFVJQ29udHJvbGxlci51cGRhdGVDb3VudGVycygpO1xyXG4gICAgfSxcclxuXHJcbiAgICBoYW5kbGVDdXN0b21TdGlja2VyU2VsZWN0aW9uKGV2ZW50KSB7XHJcbiAgICAgICAgY29uc3QgcHJldmlld1dyYXBwZXIgPSBkb2N1bWVudC5xdWVyeVNlbGVjdG9yKFNFTEVDVE9SUy5wcmV2aWV3LndyYXBwZXIpO1xyXG5cclxuICAgICAgICBpZiAoZXZlbnQudGFyZ2V0LmNoZWNrZWQgJiYgcHJldmlld1dyYXBwZXIuY2hpbGRyZW4ubGVuZ3RoID09PSAwKSB7XHJcbiAgICAgICAgICAgIEN1c3RvbVN0aWNrZXJBcHAuc2hvd0N1c3RvbVN0aWNrZXJTaWRlYmFyKGV2ZW50KTtcclxuICAgICAgICB9XHJcbiAgICB9LFxyXG5cclxuICAgIGhhbmRsZUZvcm1TdWJtaXQoZXZlbnQpIHtcclxuICAgICAgICBldmVudC5wcmV2ZW50RGVmYXVsdCgpO1xyXG4gICAgICAgIGNvbnN0IGZvcm0gPSBldmVudC50YXJnZXQ7XHJcbiAgICAgICAgY29uc3QgZm9ybURhdGEgPSBuZXcgRm9ybURhdGEoZm9ybSk7XHJcbiAgICAgICAgY29uc3QgcHJldmlld0VsZW1lbnQgPSBkb2N1bWVudC5xdWVyeVNlbGVjdG9yKCcuY3VzdG9tLXN0aWNrZXJfX3ByZXZpZXcnKTtcclxuICAgICAgICBsZXQgdGVtcEltYWdlO1xyXG5cclxuICAgICAgICBsZXQgaHRtbFRvSW1hZ2VDb25maWcgPSB7IGNhY2hlQnVzdDogdHJ1ZSB9XHJcbiAgICAgICAgaWYobmF2aWdhdG9yLnVzZXJBZ2VudC50b0xvd2VyQ2FzZSgpLmluZGV4T2YoJ2ZpcmVmb3gnKSA+IC0xKSB7XHJcbiAgICAgICAgICAgIGh0bWxUb0ltYWdlQ29uZmlnID0geyBjYWNoZUJ1c3Q6IHRydWUsIHNraXBGb250czogdHJ1ZSB9XHJcbiAgICAgICAgfVxyXG5cclxuICAgICAgICBodG1sVG9JbWFnZS50b1BuZyhwcmV2aWV3RWxlbWVudCwgaHRtbFRvSW1hZ2VDb25maWcpXHJcbiAgICAgICAgICAgIC50aGVuKGN1c3RvbVN0aWNrZXJJbWFnZSA9PiB7XHJcbiAgICAgICAgICAgICAgICB0ZW1wSW1hZ2UgPSBjdXN0b21TdGlja2VySW1hZ2U7XHJcbiAgICAgICAgICAgICAgICBmb3JtRGF0YS5hcHBlbmQoJ2N1c3RvbV9zdGlja2VyW2ltYWdlXScsIGN1c3RvbVN0aWNrZXJJbWFnZSk7XHJcbiAgICAgICAgICAgICAgICByZXR1cm4gQVBJU2VydmljZS5zYXZlQ3VzdG9tU3RpY2tlcihmb3JtRGF0YSk7XHJcbiAgICAgICAgICAgIH0pXHJcbiAgICAgICAgICAgIC50aGVuKGRhdGEgPT4ge1xyXG4gICAgICAgICAgICAgICAgaWYgKGRhdGEuc3VjY2Vzcykge1xyXG4gICAgICAgICAgICAgICAgICAgIFVJQ29udHJvbGxlci5jbG9zZVNpZGViYXIoKTtcclxuICAgICAgICAgICAgICAgICAgICBkb2N1bWVudC5xdWVyeVNlbGVjdG9yQWxsKFNFTEVDVE9SUy5wcmV2aWV3LmltYWdlKVxyXG4gICAgICAgICAgICAgICAgICAgICAgICAuZm9yRWFjaChpbWFnZSA9PiBpbWFnZS5zcmMgPSB0ZW1wSW1hZ2UpO1xyXG4gICAgICAgICAgICAgICAgICAgIGRvY3VtZW50LnF1ZXJ5U2VsZWN0b3IoU0VMRUNUT1JTLnByZXZpZXcud3JhcHBlcikuaW5uZXJIVE1MID0gZGF0YS5tZXNzYWdlLnByZXZpZXc7XHJcbiAgICAgICAgICAgICAgICB9XHJcbiAgICAgICAgICAgIH0pXHJcbiAgICAgICAgICAgIC5jYXRjaChlcnJvciA9PiBjb25zb2xlLmVycm9yKCdFcnJvcjonLCBlcnJvcikpO1xyXG4gICAgfVxyXG59O1xyXG5cclxuZXhwb3J0IGNvbnN0IEN1c3RvbVN0aWNrZXJBcHAgPSB7XHJcbiAgICBpbml0KCkge1xyXG4gICAgICAgIGlmICghd2luZG93LmN1c3RvbVN0aWNrZXJJbml0aWFsaXplZCkge1xyXG4gICAgICAgICAgICBkb2N1bWVudC5hZGRFdmVudExpc3RlbmVyKCdET01Db250ZW50TG9hZGVkJywgKCkgPT4gdGhpcy5pbml0aWFsaXplU2lkZWJhckNvbnRyb2xzKCksIHtvbmNlOiB0cnVlfSk7XHJcbiAgICAgICAgICAgIHdpbmRvdy5jdXN0b21TdGlja2VySW5pdGlhbGl6ZWQgPSB0cnVlO1xyXG4gICAgICAgIH1cclxuICAgIH0sXHJcblxyXG4gICAgaW5pdGlhbGl6ZUFsbCgpIHtcclxuICAgICAgICB0aGlzLmluaXRpYWxpemVDdXN0b21TdGlja2VySW5wdXRzKCk7XHJcbiAgICAgICAgVUlDb250cm9sbGVyLnVwZGF0ZVByZXZpZXcoKTtcclxuICAgICAgICBVSUNvbnRyb2xsZXIudXBkYXRlQ291bnRlcnMoKTtcclxuICAgIH0sXHJcblxyXG4gICAgaW5pdGlhbGl6ZVNpZGViYXJDb250cm9scygpIHtcclxuICAgICAgICBjb25zdCBjbG9zZUJ1dHRvbnMgPSBkb2N1bWVudC5xdWVyeVNlbGVjdG9yQWxsKCcuanMtY2xvc2UtY3VzdG9tLXN0aWNrZXItc2lkZWJhcicpO1xyXG4gICAgICAgIGNvbnN0IG9wdGlvbnMgPSBkb2N1bWVudC5xdWVyeVNlbGVjdG9yQWxsKCcuanMtY3VzdG9tLXN0aWNrZXItb3B0aW9uJyk7XHJcbiAgICAgICAgY29uc3Qgc2xpZGVPdXQgPSBkb2N1bWVudC5xdWVyeVNlbGVjdG9yKFNFTEVDVE9SUy5zbGlkZU91dCk7XHJcblxyXG4gICAgICAgIGRvY3VtZW50LmJvZHkuYWRkRXZlbnRMaXN0ZW5lcignY2xpY2snLCBlID0+IHtcclxuICAgICAgICAgICAgY29uc3Qgb3BlbkJ1dHRvbiA9IGUudGFyZ2V0LmNsb3Nlc3QoJy5qcy1vcGVuLWN1c3RvbS1zdGlja2VyJyk7XHJcbiAgICAgICAgICAgIGlmIChvcGVuQnV0dG9uKSB7XHJcbiAgICAgICAgICAgICAgICB0aGlzLnNob3dDdXN0b21TdGlja2VyU2lkZWJhcih7Y3VycmVudFRhcmdldDogb3BlbkJ1dHRvbn0pO1xyXG4gICAgICAgICAgICB9XHJcbiAgICAgICAgfSk7XHJcblxyXG4gICAgICAgIC8vIERpc3BsYXkgY3VzdG9tIHN0aWNrZXIgc2lkZWJhciB3aGVuIHRoZSB1c2VyIHdhbnRzIHRvIGFkZCBhIHByb2R1Y3Qgd2l0aCBhIGN1c3RvbSBzdGlja2VyIHRoYXQgdGhleSBoYXZlbid0IHBlcnNvbmFsaXplZCB5ZXRcclxuICAgICAgICBkb2N1bWVudC5hZGRFdmVudExpc3RlbmVyKCdjbGljaycsIChldmVudCkgPT4ge1xyXG4gICAgICAgICAgICBpZiAoZXZlbnQudGFyZ2V0LmNsb3Nlc3QoJy5qcy1hZGQtcHJvZHVjdC10by1jYXJ0JykpIHtcclxuICAgICAgICAgICAgICAgIGNvbnN0IGN1c3RvbVN0aWNrZXJFbGVtZW50ID0gZG9jdW1lbnQucXVlcnlTZWxlY3RvcignLmpzLWN1c3RvbS1zdGlja2VyLW9wdGlvbicpO1xyXG4gICAgICAgICAgICAgICAgY29uc3QgaXNDdXN0b21TdGlja2VyQ2hlY2tlZCA9IGN1c3RvbVN0aWNrZXJFbGVtZW50ID8gY3VzdG9tU3RpY2tlckVsZW1lbnQuY2hlY2tlZCA6IGZhbHNlO1xyXG4gICAgICAgICAgICAgICAgY29uc3QgcHJldmlld0NvbnRhaW5lciA9IGRvY3VtZW50LnF1ZXJ5U2VsZWN0b3IoJy5qcy1jdXN0b20tc3RpY2tlci1wcm9kdWN0LXByZXZpZXctY29udGFpbmVyJyk7XHJcblxyXG4gICAgICAgICAgICAgICAgaWYgKGlzQ3VzdG9tU3RpY2tlckNoZWNrZWQgJiYgIXByZXZpZXdDb250YWluZXIpIHtcclxuICAgICAgICAgICAgICAgICAgICBldmVudC5wcmV2ZW50RGVmYXVsdCgpO1xyXG4gICAgICAgICAgICAgICAgICAgIGV2ZW50LnN0b3BQcm9wYWdhdGlvbigpO1xyXG5cclxuICAgICAgICAgICAgICAgICAgICBjb25zdCBvcGVuQ3VzdG9tU3RpY2tlckJ1dHRvbiA9IGRvY3VtZW50LnF1ZXJ5U2VsZWN0b3IoJy5qcy1vcGVuLWN1c3RvbS1zdGlja2VyJyk7XHJcbiAgICAgICAgICAgICAgICAgICAgaWYgKG9wZW5DdXN0b21TdGlja2VyQnV0dG9uKSB7XHJcbiAgICAgICAgICAgICAgICAgICAgICAgIHRoaXMuc2hvd0N1c3RvbVN0aWNrZXJTaWRlYmFyKHtjdXJyZW50VGFyZ2V0OiBvcGVuQ3VzdG9tU3RpY2tlckJ1dHRvbn0pO1xyXG4gICAgICAgICAgICAgICAgICAgIH1cclxuICAgICAgICAgICAgICAgIH1cclxuICAgICAgICAgICAgfVxyXG4gICAgICAgIH0sIHRydWUpO1xyXG5cclxuICAgICAgICBvcHRpb25zLmZvckVhY2gob3B0aW9uID0+XHJcbiAgICAgICAgICAgIG9wdGlvbi5hZGRFdmVudExpc3RlbmVyKCdjaGFuZ2UnLCBFdmVudEhhbmRsZXJzLmhhbmRsZUN1c3RvbVN0aWNrZXJTZWxlY3Rpb24pXHJcbiAgICAgICAgKTtcclxuXHJcbiAgICAgICAgaWYgKHNsaWRlT3V0KSB7XHJcbiAgICAgICAgICAgIHNsaWRlT3V0LmFkZEV2ZW50TGlzdGVuZXIoJ2NsaWNrJywgVUlDb250cm9sbGVyLmNsb3NlU2lkZWJhcik7XHJcbiAgICAgICAgfVxyXG5cclxuICAgICAgICBjbG9zZUJ1dHRvbnMuZm9yRWFjaChidXR0b24gPT5cclxuICAgICAgICAgICAgYnV0dG9uLmFkZEV2ZW50TGlzdGVuZXIoJ2NsaWNrJywgVUlDb250cm9sbGVyLmNsb3NlU2lkZWJhcilcclxuICAgICAgICApO1xyXG4gICAgfSxcclxuXHJcbiAgICBpbml0aWFsaXplQ3VzdG9tU3RpY2tlcklucHV0cygpIHtcclxuICAgICAgICBjb25zdCBpbnB1dHMgPSBkb2N1bWVudC5xdWVyeVNlbGVjdG9yQWxsKFNFTEVDVE9SUy5pbnB1dHMuaW5wdXRzKTtcclxuXHJcbiAgICAgICAgaW5wdXRzLmZvckVhY2goaW5wdXQgPT4ge1xyXG4gICAgICAgICAgICBjb25zdCBjb25maWcgPSBDT05GSUdbaW5wdXQuZGF0YXNldC50eXBlXTtcclxuXHJcbiAgICAgICAgICAgIGlucHV0LmFkZEV2ZW50TGlzdGVuZXIoJ2lucHV0JywgZSA9PlxyXG4gICAgICAgICAgICAgICAgRXZlbnRIYW5kbGVycy5oYW5kbGVUZXh0SW5wdXQoZSwgY29uZmlnKVxyXG4gICAgICAgICAgICApO1xyXG4gICAgICAgIH0pO1xyXG4gICAgfSxcclxuXHJcbiAgICBzaG93Q3VzdG9tU3RpY2tlclNpZGViYXIoZXZlbnQpIHtcclxuICAgICAgICBjb25zdCB7IHN0aWNrZXJJZCwgcHJvZHVjdElkID0gbnVsbCB9ID0gZXZlbnQuY3VycmVudFRhcmdldC5kYXRhc2V0O1xyXG5cclxuICAgICAgICBBUElTZXJ2aWNlLmdldEN1c3RvbVN0aWNrZXIocHJvZHVjdElkLCBzdGlja2VySWQpXHJcbiAgICAgICAgICAgIC50aGVuKGRhdGEgPT4ge1xyXG4gICAgICAgICAgICAgICAgaWYgKGRhdGEuc3VjY2Vzcykge1xyXG4gICAgICAgICAgICAgICAgICAgIGlmIChkYXRhLm1lc3NhZ2UuaGFzQW5vdGhlckN1c3RvbVN0aWNrZXJJbk9yZGVyKSB7XHJcbiAgICAgICAgICAgICAgICAgICAgICAgIGRvY3VtZW50LnF1ZXJ5U2VsZWN0b3IoU0VMRUNUT1JTLndpZGdldHMubWFpbikuY2xhc3NMaXN0LmFkZCgnaGlkZScpO1xyXG4gICAgICAgICAgICAgICAgICAgICAgICBkb2N1bWVudC5xdWVyeVNlbGVjdG9yKFNFTEVDVE9SUy5wcmV2aWV3LndyYXBwZXIpLmNsYXNzTGlzdC5hZGQoJ2hpZGUnKTtcclxuICAgICAgICAgICAgICAgICAgICAgICAgZG9jdW1lbnQucXVlcnlTZWxlY3RvcihTRUxFQ1RPUlMud2lkZ2V0cy5hbHJlYWR5RXhpc3RzKS5jbGFzc0xpc3QucmVtb3ZlKCdoaWRlJyk7XHJcbiAgICAgICAgICAgICAgICAgICAgfSBlbHNlIHtcclxuICAgICAgICAgICAgICAgICAgICAgICAgVUlDb250cm9sbGVyLnNob3dTaWRlYmFyKCk7XHJcbiAgICAgICAgICAgICAgICAgICAgICAgIGRvY3VtZW50LnF1ZXJ5U2VsZWN0b3IoU0VMRUNUT1JTLmNvbnRlbnQpLmlubmVySFRNTCA9IGRhdGEubWVzc2FnZS5zaWRlYmFyO1xyXG4gICAgICAgICAgICAgICAgICAgICAgICB0aGlzLmluaXRpYWxpemVBbGwoKVxyXG5cclxuICAgICAgICAgICAgICAgICAgICAgICAgY29uc3QgZm9ybSA9IGRvY3VtZW50LnF1ZXJ5U2VsZWN0b3IoU0VMRUNUT1JTLmZvcm0pO1xyXG4gICAgICAgICAgICAgICAgICAgICAgICBmb3JtLmFkZEV2ZW50TGlzdGVuZXIoJ3N1Ym1pdCcsIEV2ZW50SGFuZGxlcnMuaGFuZGxlRm9ybVN1Ym1pdCk7XHJcbiAgICAgICAgICAgICAgICAgICAgfVxyXG4gICAgICAgICAgICAgICAgfVxyXG4gICAgICAgICAgICB9KVxyXG4gICAgICAgICAgICAuY2F0Y2goZXJyb3IgPT4gY29uc29sZS5lcnJvcignRXJyb3I6JywgZXJyb3IpKTtcclxuICAgIH1cclxufTtcclxuXHJcbkN1c3RvbVN0aWNrZXJBcHAuaW5pdCgpOyJdfQ==
},{"html-to-image":10}],2:[function(require,module,exports){
// shim for using process in browser

var process = module.exports = {};

process.nextTick = (function () {
    var canSetImmediate = typeof window !== 'undefined'
    && window.setImmediate;
    var canPost = typeof window !== 'undefined'
    && window.postMessage && window.addEventListener
    ;

    if (canSetImmediate) {
        return function (f) { return window.setImmediate(f) };
    }

    if (canPost) {
        var queue = [];
        window.addEventListener('message', function (ev) {
            var source = ev.source;
            if ((source === window || source === null) && ev.data === 'process-tick') {
                ev.stopPropagation();
                if (queue.length > 0) {
                    var fn = queue.shift();
                    fn();
                }
            }
        }, true);

        return function nextTick(fn) {
            queue.push(fn);
            window.postMessage('process-tick', '*');
        };
    }

    return function nextTick(fn) {
        setTimeout(fn, 0);
    };
})();

process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;

process.binding = function (name) {
    throw new Error('process.binding is not supported');
}

// TODO(shtylman)
process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};

},{}],3:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyStyle = void 0;
function applyStyle(node, options) {
    var style = node.style;
    if (options.backgroundColor) {
        style.backgroundColor = options.backgroundColor;
    }
    if (options.width) {
        style.width = "".concat(options.width, "px");
    }
    if (options.height) {
        style.height = "".concat(options.height, "px");
    }
    var manual = options.style;
    if (manual != null) {
        Object.keys(manual).forEach(function (key) {
            style[key] = manual[key];
        });
    }
    return node;
}
exports.applyStyle = applyStyle;
//# sourceMappingURL=apply-style.js.map
},{}],4:[function(require,module,exports){
"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.cloneNode = void 0;
var clone_pseudos_1 = require("./clone-pseudos");
var util_1 = require("./util");
var mimes_1 = require("./mimes");
var dataurl_1 = require("./dataurl");
function cloneCanvasElement(canvas) {
    return __awaiter(this, void 0, void 0, function () {
        var dataURL;
        return __generator(this, function (_a) {
            dataURL = canvas.toDataURL();
            if (dataURL === 'data:,') {
                return [2 /*return*/, canvas.cloneNode(false)];
            }
            return [2 /*return*/, (0, util_1.createImage)(dataURL)];
        });
    });
}
function cloneVideoElement(video, options) {
    return __awaiter(this, void 0, void 0, function () {
        var canvas, ctx, dataURL_1, poster, contentType, dataURL;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (video.currentSrc) {
                        canvas = document.createElement('canvas');
                        ctx = canvas.getContext('2d');
                        canvas.width = video.clientWidth;
                        canvas.height = video.clientHeight;
                        ctx === null || ctx === void 0 ? void 0 : ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                        dataURL_1 = canvas.toDataURL();
                        return [2 /*return*/, (0, util_1.createImage)(dataURL_1)];
                    }
                    poster = video.poster;
                    contentType = (0, mimes_1.getMimeType)(poster);
                    return [4 /*yield*/, (0, dataurl_1.resourceToDataURL)(poster, contentType, options)];
                case 1:
                    dataURL = _a.sent();
                    return [2 /*return*/, (0, util_1.createImage)(dataURL)];
            }
        });
    });
}
function cloneIFrameElement(iframe) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 3, , 4]);
                    if (!((_a = iframe === null || iframe === void 0 ? void 0 : iframe.contentDocument) === null || _a === void 0 ? void 0 : _a.body)) return [3 /*break*/, 2];
                    return [4 /*yield*/, cloneNode(iframe.contentDocument.body, {}, true)];
                case 1: return [2 /*return*/, (_c.sent())];
                case 2: return [3 /*break*/, 4];
                case 3:
                    _b = _c.sent();
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/, iframe.cloneNode(false)];
            }
        });
    });
}
function cloneSingleNode(node, options) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if ((0, util_1.isInstanceOfElement)(node, HTMLCanvasElement)) {
                return [2 /*return*/, cloneCanvasElement(node)];
            }
            if ((0, util_1.isInstanceOfElement)(node, HTMLVideoElement)) {
                return [2 /*return*/, cloneVideoElement(node, options)];
            }
            if ((0, util_1.isInstanceOfElement)(node, HTMLIFrameElement)) {
                return [2 /*return*/, cloneIFrameElement(node)];
            }
            return [2 /*return*/, node.cloneNode(isSVGElement(node))];
        });
    });
}
var isSlotElement = function (node) {
    return node.tagName != null && node.tagName.toUpperCase() === 'SLOT';
};
var isSVGElement = function (node) {
    return node.tagName != null && node.tagName.toUpperCase() === 'SVG';
};
function cloneChildren(nativeNode, clonedNode, options) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function () {
        var children;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (isSVGElement(clonedNode)) {
                        return [2 /*return*/, clonedNode];
                    }
                    children = [];
                    if (isSlotElement(nativeNode) && nativeNode.assignedNodes) {
                        children = (0, util_1.toArray)(nativeNode.assignedNodes());
                    }
                    else if ((0, util_1.isInstanceOfElement)(nativeNode, HTMLIFrameElement) &&
                        ((_a = nativeNode.contentDocument) === null || _a === void 0 ? void 0 : _a.body)) {
                        children = (0, util_1.toArray)(nativeNode.contentDocument.body.childNodes);
                    }
                    else {
                        children = (0, util_1.toArray)(((_b = nativeNode.shadowRoot) !== null && _b !== void 0 ? _b : nativeNode).childNodes);
                    }
                    if (children.length === 0 ||
                        (0, util_1.isInstanceOfElement)(nativeNode, HTMLVideoElement)) {
                        return [2 /*return*/, clonedNode];
                    }
                    return [4 /*yield*/, children.reduce(function (deferred, child) {
                            return deferred
                                .then(function () { return cloneNode(child, options); })
                                .then(function (clonedChild) {
                                if (clonedChild) {
                                    clonedNode.appendChild(clonedChild);
                                }
                            });
                        }, Promise.resolve())];
                case 1:
                    _c.sent();
                    return [2 /*return*/, clonedNode];
            }
        });
    });
}
function cloneCSSStyle(nativeNode, clonedNode) {
    var targetStyle = clonedNode.style;
    if (!targetStyle) {
        return;
    }
    var sourceStyle = window.getComputedStyle(nativeNode);
    if (sourceStyle.cssText) {
        targetStyle.cssText = sourceStyle.cssText;
        targetStyle.transformOrigin = sourceStyle.transformOrigin;
    }
    else {
        (0, util_1.toArray)(sourceStyle).forEach(function (name) {
            var value = sourceStyle.getPropertyValue(name);
            if (name === 'font-size' && value.endsWith('px')) {
                var reducedFont = Math.floor(parseFloat(value.substring(0, value.length - 2))) - 0.1;
                value = "".concat(reducedFont, "px");
            }
            if ((0, util_1.isInstanceOfElement)(nativeNode, HTMLIFrameElement) &&
                name === 'display' &&
                value === 'inline') {
                value = 'block';
            }
            if (name === 'd' && clonedNode.getAttribute('d')) {
                value = "path(".concat(clonedNode.getAttribute('d'), ")");
            }
            targetStyle.setProperty(name, value, sourceStyle.getPropertyPriority(name));
        });
    }
}
function cloneInputValue(nativeNode, clonedNode) {
    if ((0, util_1.isInstanceOfElement)(nativeNode, HTMLTextAreaElement)) {
        clonedNode.innerHTML = nativeNode.value;
    }
    if ((0, util_1.isInstanceOfElement)(nativeNode, HTMLInputElement)) {
        clonedNode.setAttribute('value', nativeNode.value);
    }
}
function cloneSelectValue(nativeNode, clonedNode) {
    if ((0, util_1.isInstanceOfElement)(nativeNode, HTMLSelectElement)) {
        var clonedSelect = clonedNode;
        var selectedOption = Array.from(clonedSelect.children).find(function (child) { return nativeNode.value === child.getAttribute('value'); });
        if (selectedOption) {
            selectedOption.setAttribute('selected', '');
        }
    }
}
function decorate(nativeNode, clonedNode) {
    if ((0, util_1.isInstanceOfElement)(clonedNode, Element)) {
        cloneCSSStyle(nativeNode, clonedNode);
        (0, clone_pseudos_1.clonePseudoElements)(nativeNode, clonedNode);
        cloneInputValue(nativeNode, clonedNode);
        cloneSelectValue(nativeNode, clonedNode);
    }
    return clonedNode;
}
function ensureSVGSymbols(clone, options) {
    return __awaiter(this, void 0, void 0, function () {
        var uses, processedDefs, i, use, id, exist, definition, _a, _b, nodes, ns, svg, defs, i;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    uses = clone.querySelectorAll ? clone.querySelectorAll('use') : [];
                    if (uses.length === 0) {
                        return [2 /*return*/, clone];
                    }
                    processedDefs = {};
                    i = 0;
                    _c.label = 1;
                case 1:
                    if (!(i < uses.length)) return [3 /*break*/, 4];
                    use = uses[i];
                    id = use.getAttribute('xlink:href');
                    if (!id) return [3 /*break*/, 3];
                    exist = clone.querySelector(id);
                    definition = document.querySelector(id);
                    if (!(!exist && definition && !processedDefs[id])) return [3 /*break*/, 3];
                    // eslint-disable-next-line no-await-in-loop
                    _a = processedDefs;
                    _b = id;
                    return [4 /*yield*/, cloneNode(definition, options, true)];
                case 2:
                    // eslint-disable-next-line no-await-in-loop
                    _a[_b] = (_c.sent());
                    _c.label = 3;
                case 3:
                    i++;
                    return [3 /*break*/, 1];
                case 4:
                    nodes = Object.values(processedDefs);
                    if (nodes.length) {
                        ns = 'http://www.w3.org/1999/xhtml';
                        svg = document.createElementNS(ns, 'svg');
                        svg.setAttribute('xmlns', ns);
                        svg.style.position = 'absolute';
                        svg.style.width = '0';
                        svg.style.height = '0';
                        svg.style.overflow = 'hidden';
                        svg.style.display = 'none';
                        defs = document.createElementNS(ns, 'defs');
                        svg.appendChild(defs);
                        for (i = 0; i < nodes.length; i++) {
                            defs.appendChild(nodes[i]);
                        }
                        clone.appendChild(svg);
                    }
                    return [2 /*return*/, clone];
            }
        });
    });
}
function cloneNode(node, options, isRoot) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (!isRoot && options.filter && !options.filter(node)) {
                return [2 /*return*/, null];
            }
            return [2 /*return*/, Promise.resolve(node)
                    .then(function (clonedNode) { return cloneSingleNode(clonedNode, options); })
                    .then(function (clonedNode) { return cloneChildren(node, clonedNode, options); })
                    .then(function (clonedNode) { return decorate(node, clonedNode); })
                    .then(function (clonedNode) { return ensureSVGSymbols(clonedNode, options); })];
        });
    });
}
exports.cloneNode = cloneNode;
//# sourceMappingURL=clone-node.js.map
},{"./clone-pseudos":5,"./dataurl":6,"./mimes":11,"./util":12}],5:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clonePseudoElements = void 0;
var util_1 = require("./util");
function formatCSSText(style) {
    var content = style.getPropertyValue('content');
    return "".concat(style.cssText, " content: '").concat(content.replace(/'|"/g, ''), "';");
}
function formatCSSProperties(style) {
    return (0, util_1.toArray)(style)
        .map(function (name) {
        var value = style.getPropertyValue(name);
        var priority = style.getPropertyPriority(name);
        return "".concat(name, ": ").concat(value).concat(priority ? ' !important' : '', ";");
    })
        .join(' ');
}
function getPseudoElementStyle(className, pseudo, style) {
    var selector = ".".concat(className, ":").concat(pseudo);
    var cssText = style.cssText
        ? formatCSSText(style)
        : formatCSSProperties(style);
    return document.createTextNode("".concat(selector, "{").concat(cssText, "}"));
}
function clonePseudoElement(nativeNode, clonedNode, pseudo) {
    var style = window.getComputedStyle(nativeNode, pseudo);
    var content = style.getPropertyValue('content');
    if (content === '' || content === 'none') {
        return;
    }
    var className = (0, util_1.uuid)();
    try {
        clonedNode.className = "".concat(clonedNode.className, " ").concat(className);
    }
    catch (err) {
        return;
    }
    var styleElement = document.createElement('style');
    styleElement.appendChild(getPseudoElementStyle(className, pseudo, style));
    clonedNode.appendChild(styleElement);
}
function clonePseudoElements(nativeNode, clonedNode) {
    clonePseudoElement(nativeNode, clonedNode, ':before');
    clonePseudoElement(nativeNode, clonedNode, ':after');
}
exports.clonePseudoElements = clonePseudoElements;
//# sourceMappingURL=clone-pseudos.js.map
},{"./util":12}],6:[function(require,module,exports){
"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.resourceToDataURL = exports.fetchAsDataURL = exports.makeDataUrl = exports.isDataUrl = void 0;
function getContentFromDataUrl(dataURL) {
    return dataURL.split(/,/)[1];
}
function isDataUrl(url) {
    return url.search(/^(data:)/) !== -1;
}
exports.isDataUrl = isDataUrl;
function makeDataUrl(content, mimeType) {
    return "data:".concat(mimeType, ";base64,").concat(content);
}
exports.makeDataUrl = makeDataUrl;
function fetchAsDataURL(url, init, process) {
    return __awaiter(this, void 0, void 0, function () {
        var res, blob;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetch(url, init)];
                case 1:
                    res = _a.sent();
                    if (res.status === 404) {
                        throw new Error("Resource \"".concat(res.url, "\" not found"));
                    }
                    return [4 /*yield*/, res.blob()];
                case 2:
                    blob = _a.sent();
                    return [2 /*return*/, new Promise(function (resolve, reject) {
                            var reader = new FileReader();
                            reader.onerror = reject;
                            reader.onloadend = function () {
                                try {
                                    resolve(process({ res: res, result: reader.result }));
                                }
                                catch (error) {
                                    reject(error);
                                }
                            };
                            reader.readAsDataURL(blob);
                        })];
            }
        });
    });
}
exports.fetchAsDataURL = fetchAsDataURL;
var cache = {};
function getCacheKey(url, contentType, includeQueryParams) {
    var key = url.replace(/\?.*/, '');
    if (includeQueryParams) {
        key = url;
    }
    // font resource
    if (/ttf|otf|eot|woff2?/i.test(key)) {
        key = key.replace(/.*\//, '');
    }
    return contentType ? "[".concat(contentType, "]").concat(key) : key;
}
function resourceToDataURL(resourceUrl, contentType, options) {
    return __awaiter(this, void 0, void 0, function () {
        var cacheKey, dataURL, content, error_1, msg;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    cacheKey = getCacheKey(resourceUrl, contentType, options.includeQueryParams);
                    if (cache[cacheKey] != null) {
                        return [2 /*return*/, cache[cacheKey]];
                    }
                    // ref: https://developer.mozilla.org/en/docs/Web/API/XMLHttpRequest/Using_XMLHttpRequest#Bypassing_the_cache
                    if (options.cacheBust) {
                        // eslint-disable-next-line no-param-reassign
                        resourceUrl += (/\?/.test(resourceUrl) ? '&' : '?') + new Date().getTime();
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, fetchAsDataURL(resourceUrl, options.fetchRequestInit, function (_a) {
                            var res = _a.res, result = _a.result;
                            if (!contentType) {
                                // eslint-disable-next-line no-param-reassign
                                contentType = res.headers.get('Content-Type') || '';
                            }
                            return getContentFromDataUrl(result);
                        })];
                case 2:
                    content = _a.sent();
                    dataURL = makeDataUrl(content, contentType);
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    dataURL = options.imagePlaceholder || '';
                    msg = "Failed to fetch resource: ".concat(resourceUrl);
                    if (error_1) {
                        msg = typeof error_1 === 'string' ? error_1 : error_1.message;
                    }
                    if (msg) {
                        console.warn(msg);
                    }
                    return [3 /*break*/, 4];
                case 4:
                    cache[cacheKey] = dataURL;
                    return [2 /*return*/, dataURL];
            }
        });
    });
}
exports.resourceToDataURL = resourceToDataURL;
//# sourceMappingURL=dataurl.js.map
},{}],7:[function(require,module,exports){
"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.embedImages = void 0;
var embed_resources_1 = require("./embed-resources");
var util_1 = require("./util");
var dataurl_1 = require("./dataurl");
var mimes_1 = require("./mimes");
function embedProp(propName, node, options) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var propValue, cssString;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    propValue = (_a = node.style) === null || _a === void 0 ? void 0 : _a.getPropertyValue(propName);
                    if (!propValue) return [3 /*break*/, 2];
                    return [4 /*yield*/, (0, embed_resources_1.embedResources)(propValue, null, options)];
                case 1:
                    cssString = _b.sent();
                    node.style.setProperty(propName, cssString, node.style.getPropertyPriority(propName));
                    return [2 /*return*/, true];
                case 2: return [2 /*return*/, false];
            }
        });
    });
}
function embedBackground(clonedNode, options) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, embedProp('background', clonedNode, options)];
                case 1:
                    if (!!(_a.sent())) return [3 /*break*/, 3];
                    return [4 /*yield*/, embedProp('background-image', clonedNode, options)];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3: return [4 /*yield*/, embedProp('mask', clonedNode, options)];
                case 4:
                    if (!!(_a.sent())) return [3 /*break*/, 6];
                    return [4 /*yield*/, embedProp('mask-image', clonedNode, options)];
                case 5:
                    _a.sent();
                    _a.label = 6;
                case 6: return [2 /*return*/];
            }
        });
    });
}
function embedImageNode(clonedNode, options) {
    return __awaiter(this, void 0, void 0, function () {
        var isImageElement, url, dataURL;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    isImageElement = (0, util_1.isInstanceOfElement)(clonedNode, HTMLImageElement);
                    if (!(isImageElement && !(0, dataurl_1.isDataUrl)(clonedNode.src)) &&
                        !((0, util_1.isInstanceOfElement)(clonedNode, SVGImageElement) &&
                            !(0, dataurl_1.isDataUrl)(clonedNode.href.baseVal))) {
                        return [2 /*return*/];
                    }
                    url = isImageElement ? clonedNode.src : clonedNode.href.baseVal;
                    return [4 /*yield*/, (0, dataurl_1.resourceToDataURL)(url, (0, mimes_1.getMimeType)(url), options)];
                case 1:
                    dataURL = _a.sent();
                    return [4 /*yield*/, new Promise(function (resolve, reject) {
                            clonedNode.onload = resolve;
                            clonedNode.onerror = options.onImageErrorHandler
                                ? function () {
                                    var attributes = [];
                                    for (var _i = 0; _i < arguments.length; _i++) {
                                        attributes[_i] = arguments[_i];
                                    }
                                    try {
                                        resolve(options.onImageErrorHandler.apply(options, attributes));
                                    }
                                    catch (error) {
                                        reject(error);
                                    }
                                }
                                : reject;
                            var image = clonedNode;
                            if (image.decode) {
                                image.decode = resolve;
                            }
                            if (image.loading === 'lazy') {
                                image.loading = 'eager';
                            }
                            if (isImageElement) {
                                clonedNode.srcset = '';
                                clonedNode.src = dataURL;
                            }
                            else {
                                clonedNode.href.baseVal = dataURL;
                            }
                        })];
                case 2:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
function embedChildren(clonedNode, options) {
    return __awaiter(this, void 0, void 0, function () {
        var children, deferreds;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    children = (0, util_1.toArray)(clonedNode.childNodes);
                    deferreds = children.map(function (child) { return embedImages(child, options); });
                    return [4 /*yield*/, Promise.all(deferreds).then(function () { return clonedNode; })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
function embedImages(clonedNode, options) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(0, util_1.isInstanceOfElement)(clonedNode, Element)) return [3 /*break*/, 4];
                    return [4 /*yield*/, embedBackground(clonedNode, options)];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, embedImageNode(clonedNode, options)];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, embedChildren(clonedNode, options)];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    });
}
exports.embedImages = embedImages;
//# sourceMappingURL=embed-images.js.map
},{"./dataurl":6,"./embed-resources":8,"./mimes":11,"./util":12}],8:[function(require,module,exports){
"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.embedResources = exports.shouldEmbed = exports.embed = exports.parseURLs = void 0;
var util_1 = require("./util");
var mimes_1 = require("./mimes");
var dataurl_1 = require("./dataurl");
var URL_REGEX = /url\((['"]?)([^'"]+?)\1\)/g;
var URL_WITH_FORMAT_REGEX = /url\([^)]+\)\s*format\((["']?)([^"']+)\1\)/g;
var FONT_SRC_REGEX = /src:\s*(?:url\([^)]+\)\s*format\([^)]+\)[,;]\s*)+/g;
function toRegex(url) {
    // eslint-disable-next-line no-useless-escape
    var escaped = url.replace(/([.*+?^${}()|\[\]\/\\])/g, '\\$1');
    return new RegExp("(url\\(['\"]?)(".concat(escaped, ")(['\"]?\\))"), 'g');
}
function parseURLs(cssText) {
    var urls = [];
    cssText.replace(URL_REGEX, function (raw, quotation, url) {
        urls.push(url);
        return raw;
    });
    return urls.filter(function (url) { return !(0, dataurl_1.isDataUrl)(url); });
}
exports.parseURLs = parseURLs;
function embed(cssText, resourceURL, baseURL, options, getContentFromUrl) {
    return __awaiter(this, void 0, void 0, function () {
        var resolvedURL, contentType, dataURL, content, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 5, , 6]);
                    resolvedURL = baseURL ? (0, util_1.resolveUrl)(resourceURL, baseURL) : resourceURL;
                    contentType = (0, mimes_1.getMimeType)(resourceURL);
                    dataURL = void 0;
                    if (!getContentFromUrl) return [3 /*break*/, 2];
                    return [4 /*yield*/, getContentFromUrl(resolvedURL)];
                case 1:
                    content = _a.sent();
                    dataURL = (0, dataurl_1.makeDataUrl)(content, contentType);
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, (0, dataurl_1.resourceToDataURL)(resolvedURL, contentType, options)];
                case 3:
                    dataURL = _a.sent();
                    _a.label = 4;
                case 4: return [2 /*return*/, cssText.replace(toRegex(resourceURL), "$1".concat(dataURL, "$3"))];
                case 5:
                    error_1 = _a.sent();
                    return [3 /*break*/, 6];
                case 6: return [2 /*return*/, cssText];
            }
        });
    });
}
exports.embed = embed;
function filterPreferredFontFormat(str, _a) {
    var preferredFontFormat = _a.preferredFontFormat;
    return !preferredFontFormat
        ? str
        : str.replace(FONT_SRC_REGEX, function (match) {
            // eslint-disable-next-line no-constant-condition
            while (true) {
                var _a = URL_WITH_FORMAT_REGEX.exec(match) || [], src = _a[0], format = _a[2];
                if (!format) {
                    return '';
                }
                if (format === preferredFontFormat) {
                    return "src: ".concat(src, ";");
                }
            }
        });
}
function shouldEmbed(url) {
    return url.search(URL_REGEX) !== -1;
}
exports.shouldEmbed = shouldEmbed;
function embedResources(cssText, baseUrl, options) {
    return __awaiter(this, void 0, void 0, function () {
        var filteredCSSText, urls;
        return __generator(this, function (_a) {
            if (!shouldEmbed(cssText)) {
                return [2 /*return*/, cssText];
            }
            filteredCSSText = filterPreferredFontFormat(cssText, options);
            urls = parseURLs(filteredCSSText);
            return [2 /*return*/, urls.reduce(function (deferred, url) {
                    return deferred.then(function (css) { return embed(css, url, baseUrl, options); });
                }, Promise.resolve(filteredCSSText))];
        });
    });
}
exports.embedResources = embedResources;
//# sourceMappingURL=embed-resources.js.map
},{"./dataurl":6,"./mimes":11,"./util":12}],9:[function(require,module,exports){
"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.embedWebFonts = exports.getWebFontCSS = void 0;
var util_1 = require("./util");
var dataurl_1 = require("./dataurl");
var embed_resources_1 = require("./embed-resources");
var cssFetchCache = {};
function fetchCSS(url) {
    return __awaiter(this, void 0, void 0, function () {
        var cache, res, cssText;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    cache = cssFetchCache[url];
                    if (cache != null) {
                        return [2 /*return*/, cache];
                    }
                    return [4 /*yield*/, fetch(url)];
                case 1:
                    res = _a.sent();
                    return [4 /*yield*/, res.text()];
                case 2:
                    cssText = _a.sent();
                    cache = { url: url, cssText: cssText };
                    cssFetchCache[url] = cache;
                    return [2 /*return*/, cache];
            }
        });
    });
}
function embedFonts(data, options) {
    return __awaiter(this, void 0, void 0, function () {
        var cssText, regexUrl, fontLocs, loadFonts;
        var _this = this;
        return __generator(this, function (_a) {
            cssText = data.cssText;
            regexUrl = /url\(["']?([^"')]+)["']?\)/g;
            fontLocs = cssText.match(/url\([^)]+\)/g) || [];
            loadFonts = fontLocs.map(function (loc) { return __awaiter(_this, void 0, void 0, function () {
                var url;
                return __generator(this, function (_a) {
                    url = loc.replace(regexUrl, '$1');
                    if (!url.startsWith('https://')) {
                        url = new URL(url, data.url).href;
                    }
                    return [2 /*return*/, (0, dataurl_1.fetchAsDataURL)(url, options.fetchRequestInit, function (_a) {
                            var result = _a.result;
                            cssText = cssText.replace(loc, "url(".concat(result, ")"));
                            return [loc, result];
                        })];
                });
            }); });
            return [2 /*return*/, Promise.all(loadFonts).then(function () { return cssText; })];
        });
    });
}
function parseCSS(source) {
    if (source == null) {
        return [];
    }
    var result = [];
    var commentsRegex = /(\/\*[\s\S]*?\*\/)/gi;
    // strip out comments
    var cssText = source.replace(commentsRegex, '');
    // eslint-disable-next-line prefer-regex-literals
    var keyframesRegex = new RegExp('((@.*?keyframes [\\s\\S]*?){([\\s\\S]*?}\\s*?)})', 'gi');
    // eslint-disable-next-line no-constant-condition
    while (true) {
        var matches = keyframesRegex.exec(cssText);
        if (matches === null) {
            break;
        }
        result.push(matches[0]);
    }
    cssText = cssText.replace(keyframesRegex, '');
    var importRegex = /@import[\s\S]*?url\([^)]*\)[\s\S]*?;/gi;
    // to match css & media queries together
    var combinedCSSRegex = '((\\s*?(?:\\/\\*[\\s\\S]*?\\*\\/)?\\s*?@media[\\s\\S]' +
        '*?){([\\s\\S]*?)}\\s*?})|(([\\s\\S]*?){([\\s\\S]*?)})';
    // unified regex
    var unifiedRegex = new RegExp(combinedCSSRegex, 'gi');
    // eslint-disable-next-line no-constant-condition
    while (true) {
        var matches = importRegex.exec(cssText);
        if (matches === null) {
            matches = unifiedRegex.exec(cssText);
            if (matches === null) {
                break;
            }
            else {
                importRegex.lastIndex = unifiedRegex.lastIndex;
            }
        }
        else {
            unifiedRegex.lastIndex = importRegex.lastIndex;
        }
        result.push(matches[0]);
    }
    return result;
}
function getCSSRules(styleSheets, options) {
    return __awaiter(this, void 0, void 0, function () {
        var ret, deferreds;
        return __generator(this, function (_a) {
            ret = [];
            deferreds = [];
            // First loop inlines imports
            styleSheets.forEach(function (sheet) {
                if ('cssRules' in sheet) {
                    try {
                        (0, util_1.toArray)(sheet.cssRules || []).forEach(function (item, index) {
                            if (item.type === CSSRule.IMPORT_RULE) {
                                var importIndex_1 = index + 1;
                                var url = item.href;
                                var deferred = fetchCSS(url)
                                    .then(function (metadata) { return embedFonts(metadata, options); })
                                    .then(function (cssText) {
                                    return parseCSS(cssText).forEach(function (rule) {
                                        try {
                                            sheet.insertRule(rule, rule.startsWith('@import')
                                                ? (importIndex_1 += 1)
                                                : sheet.cssRules.length);
                                        }
                                        catch (error) {
                                            console.error('Error inserting rule from remote css', {
                                                rule: rule,
                                                error: error,
                                            });
                                        }
                                    });
                                })
                                    .catch(function (e) {
                                    console.error('Error loading remote css', e.toString());
                                });
                                deferreds.push(deferred);
                            }
                        });
                    }
                    catch (e) {
                        var inline_1 = styleSheets.find(function (a) { return a.href == null; }) || document.styleSheets[0];
                        if (sheet.href != null) {
                            deferreds.push(fetchCSS(sheet.href)
                                .then(function (metadata) { return embedFonts(metadata, options); })
                                .then(function (cssText) {
                                return parseCSS(cssText).forEach(function (rule) {
                                    inline_1.insertRule(rule, sheet.cssRules.length);
                                });
                            })
                                .catch(function (err) {
                                console.error('Error loading remote stylesheet', err);
                            }));
                        }
                        console.error('Error inlining remote css file', e);
                    }
                }
            });
            return [2 /*return*/, Promise.all(deferreds).then(function () {
                    // Second loop parses rules
                    styleSheets.forEach(function (sheet) {
                        if ('cssRules' in sheet) {
                            try {
                                (0, util_1.toArray)(sheet.cssRules || []).forEach(function (item) {
                                    ret.push(item);
                                });
                            }
                            catch (e) {
                                console.error("Error while reading CSS rules from ".concat(sheet.href), e);
                            }
                        }
                    });
                    return ret;
                })];
        });
    });
}
function getWebFontRules(cssRules) {
    return cssRules
        .filter(function (rule) { return rule.type === CSSRule.FONT_FACE_RULE; })
        .filter(function (rule) { return (0, embed_resources_1.shouldEmbed)(rule.style.getPropertyValue('src')); });
}
function parseWebFontRules(node, options) {
    return __awaiter(this, void 0, void 0, function () {
        var styleSheets, cssRules;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (node.ownerDocument == null) {
                        throw new Error('Provided element is not within a Document');
                    }
                    styleSheets = (0, util_1.toArray)(node.ownerDocument.styleSheets);
                    return [4 /*yield*/, getCSSRules(styleSheets, options)];
                case 1:
                    cssRules = _a.sent();
                    return [2 /*return*/, getWebFontRules(cssRules)];
            }
        });
    });
}
function normalizeFontFamily(font) {
    return font.trim().replace(/["']/g, '');
}
function getUsedFonts(node) {
    var fonts = new Set();
    function traverse(node) {
        var fontFamily = node.style.fontFamily || getComputedStyle(node).fontFamily;
        fontFamily.split(',').forEach(function (font) {
            fonts.add(normalizeFontFamily(font));
        });
        Array.from(node.children).forEach(function (child) {
            if (child instanceof HTMLElement) {
                traverse(child);
            }
        });
    }
    traverse(node);
    return fonts;
}
function getWebFontCSS(node, options) {
    return __awaiter(this, void 0, void 0, function () {
        var rules, usedFonts, cssTexts;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, parseWebFontRules(node, options)];
                case 1:
                    rules = _a.sent();
                    usedFonts = getUsedFonts(node);
                    return [4 /*yield*/, Promise.all(rules
                            .filter(function (rule) {
                            return usedFonts.has(normalizeFontFamily(rule.style.fontFamily));
                        })
                            .map(function (rule) {
                            var baseUrl = rule.parentStyleSheet
                                ? rule.parentStyleSheet.href
                                : null;
                            return (0, embed_resources_1.embedResources)(rule.cssText, baseUrl, options);
                        }))];
                case 2:
                    cssTexts = _a.sent();
                    return [2 /*return*/, cssTexts.join('\n')];
            }
        });
    });
}
exports.getWebFontCSS = getWebFontCSS;
function embedWebFonts(clonedNode, options) {
    return __awaiter(this, void 0, void 0, function () {
        var cssText, _a, _b, styleNode, sytleContent;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!(options.fontEmbedCSS != null)) return [3 /*break*/, 1];
                    _a = options.fontEmbedCSS;
                    return [3 /*break*/, 5];
                case 1:
                    if (!options.skipFonts) return [3 /*break*/, 2];
                    _b = null;
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, getWebFontCSS(clonedNode, options)];
                case 3:
                    _b = _c.sent();
                    _c.label = 4;
                case 4:
                    _a = _b;
                    _c.label = 5;
                case 5:
                    cssText = _a;
                    if (cssText) {
                        styleNode = document.createElement('style');
                        sytleContent = document.createTextNode(cssText);
                        styleNode.appendChild(sytleContent);
                        if (clonedNode.firstChild) {
                            clonedNode.insertBefore(styleNode, clonedNode.firstChild);
                        }
                        else {
                            clonedNode.appendChild(styleNode);
                        }
                    }
                    return [2 /*return*/];
            }
        });
    });
}
exports.embedWebFonts = embedWebFonts;
//# sourceMappingURL=embed-webfonts.js.map
},{"./dataurl":6,"./embed-resources":8,"./util":12}],10:[function(require,module,exports){
"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFontEmbedCSS = exports.toBlob = exports.toJpeg = exports.toPng = exports.toPixelData = exports.toCanvas = exports.toSvg = void 0;
var clone_node_1 = require("./clone-node");
var embed_images_1 = require("./embed-images");
var apply_style_1 = require("./apply-style");
var embed_webfonts_1 = require("./embed-webfonts");
var util_1 = require("./util");
function toSvg(node, options) {
    if (options === void 0) { options = {}; }
    return __awaiter(this, void 0, void 0, function () {
        var _a, width, height, clonedNode, datauri;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = (0, util_1.getImageSize)(node, options), width = _a.width, height = _a.height;
                    return [4 /*yield*/, (0, clone_node_1.cloneNode)(node, options, true)];
                case 1:
                    clonedNode = (_b.sent());
                    return [4 /*yield*/, (0, embed_webfonts_1.embedWebFonts)(clonedNode, options)];
                case 2:
                    _b.sent();
                    return [4 /*yield*/, (0, embed_images_1.embedImages)(clonedNode, options)];
                case 3:
                    _b.sent();
                    (0, apply_style_1.applyStyle)(clonedNode, options);
                    return [4 /*yield*/, (0, util_1.nodeToDataURL)(clonedNode, width, height)];
                case 4:
                    datauri = _b.sent();
                    return [2 /*return*/, datauri];
            }
        });
    });
}
exports.toSvg = toSvg;
function toCanvas(node, options) {
    if (options === void 0) { options = {}; }
    return __awaiter(this, void 0, void 0, function () {
        var _a, width, height, svg, img, canvas, context, ratio, canvasWidth, canvasHeight;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = (0, util_1.getImageSize)(node, options), width = _a.width, height = _a.height;
                    return [4 /*yield*/, toSvg(node, options)];
                case 1:
                    svg = _b.sent();
                    return [4 /*yield*/, (0, util_1.createImage)(svg)];
                case 2:
                    img = _b.sent();
                    canvas = document.createElement('canvas');
                    context = canvas.getContext('2d');
                    ratio = options.pixelRatio || (0, util_1.getPixelRatio)();
                    canvasWidth = options.canvasWidth || width;
                    canvasHeight = options.canvasHeight || height;
                    canvas.width = canvasWidth * ratio;
                    canvas.height = canvasHeight * ratio;
                    if (!options.skipAutoScale) {
                        (0, util_1.checkCanvasDimensions)(canvas);
                    }
                    canvas.style.width = "".concat(canvasWidth);
                    canvas.style.height = "".concat(canvasHeight);
                    if (options.backgroundColor) {
                        context.fillStyle = options.backgroundColor;
                        context.fillRect(0, 0, canvas.width, canvas.height);
                    }
                    context.drawImage(img, 0, 0, canvas.width, canvas.height);
                    return [2 /*return*/, canvas];
            }
        });
    });
}
exports.toCanvas = toCanvas;
function toPixelData(node, options) {
    if (options === void 0) { options = {}; }
    return __awaiter(this, void 0, void 0, function () {
        var _a, width, height, canvas, ctx;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = (0, util_1.getImageSize)(node, options), width = _a.width, height = _a.height;
                    return [4 /*yield*/, toCanvas(node, options)];
                case 1:
                    canvas = _b.sent();
                    ctx = canvas.getContext('2d');
                    return [2 /*return*/, ctx.getImageData(0, 0, width, height).data];
            }
        });
    });
}
exports.toPixelData = toPixelData;
function toPng(node, options) {
    if (options === void 0) { options = {}; }
    return __awaiter(this, void 0, void 0, function () {
        var canvas;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, toCanvas(node, options)];
                case 1:
                    canvas = _a.sent();
                    return [2 /*return*/, canvas.toDataURL()];
            }
        });
    });
}
exports.toPng = toPng;
function toJpeg(node, options) {
    if (options === void 0) { options = {}; }
    return __awaiter(this, void 0, void 0, function () {
        var canvas;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, toCanvas(node, options)];
                case 1:
                    canvas = _a.sent();
                    return [2 /*return*/, canvas.toDataURL('image/jpeg', options.quality || 1)];
            }
        });
    });
}
exports.toJpeg = toJpeg;
function toBlob(node, options) {
    if (options === void 0) { options = {}; }
    return __awaiter(this, void 0, void 0, function () {
        var canvas, blob;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, toCanvas(node, options)];
                case 1:
                    canvas = _a.sent();
                    return [4 /*yield*/, (0, util_1.canvasToBlob)(canvas)];
                case 2:
                    blob = _a.sent();
                    return [2 /*return*/, blob];
            }
        });
    });
}
exports.toBlob = toBlob;
function getFontEmbedCSS(node, options) {
    if (options === void 0) { options = {}; }
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, (0, embed_webfonts_1.getWebFontCSS)(node, options)];
        });
    });
}
exports.getFontEmbedCSS = getFontEmbedCSS;
//# sourceMappingURL=index.js.map
},{"./apply-style":3,"./clone-node":4,"./embed-images":7,"./embed-webfonts":9,"./util":12}],11:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMimeType = void 0;
var WOFF = 'application/font-woff';
var JPEG = 'image/jpeg';
var mimes = {
    woff: WOFF,
    woff2: WOFF,
    ttf: 'application/font-truetype',
    eot: 'application/vnd.ms-fontobject',
    png: 'image/png',
    jpg: JPEG,
    jpeg: JPEG,
    gif: 'image/gif',
    tiff: 'image/tiff',
    svg: 'image/svg+xml',
    webp: 'image/webp',
};
function getExtension(url) {
    var match = /\.([^./]*?)$/g.exec(url);
    return match ? match[1] : '';
}
function getMimeType(url) {
    var extension = getExtension(url).toLowerCase();
    return mimes[extension] || '';
}
exports.getMimeType = getMimeType;
//# sourceMappingURL=mimes.js.map
},{}],12:[function(require,module,exports){
(function (process){
"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isInstanceOfElement = exports.nodeToDataURL = exports.svgToDataURL = exports.createImage = exports.canvasToBlob = exports.checkCanvasDimensions = exports.getPixelRatio = exports.getImageSize = exports.toArray = exports.delay = exports.uuid = exports.resolveUrl = void 0;
function resolveUrl(url, baseUrl) {
    // url is absolute already
    if (url.match(/^[a-z]+:\/\//i)) {
        return url;
    }
    // url is absolute already, without protocol
    if (url.match(/^\/\//)) {
        return window.location.protocol + url;
    }
    // dataURI, mailto:, tel:, etc.
    if (url.match(/^[a-z]+:/i)) {
        return url;
    }
    var doc = document.implementation.createHTMLDocument();
    var base = doc.createElement('base');
    var a = doc.createElement('a');
    doc.head.appendChild(base);
    doc.body.appendChild(a);
    if (baseUrl) {
        base.href = baseUrl;
    }
    a.href = url;
    return a.href;
}
exports.resolveUrl = resolveUrl;
exports.uuid = (function () {
    // generate uuid for className of pseudo elements.
    // We should not use GUIDs, otherwise pseudo elements sometimes cannot be captured.
    var counter = 0;
    // ref: http://stackoverflow.com/a/6248722/2519373
    var random = function () {
        // eslint-disable-next-line no-bitwise
        return "0000".concat(((Math.random() * Math.pow(36, 4)) << 0).toString(36)).slice(-4);
    };
    return function () {
        counter += 1;
        return "u".concat(random()).concat(counter);
    };
})();
function delay(ms) {
    return function (args) {
        return new Promise(function (resolve) {
            setTimeout(function () { return resolve(args); }, ms);
        });
    };
}
exports.delay = delay;
function toArray(arrayLike) {
    var arr = [];
    for (var i = 0, l = arrayLike.length; i < l; i++) {
        arr.push(arrayLike[i]);
    }
    return arr;
}
exports.toArray = toArray;
function px(node, styleProperty) {
    var win = node.ownerDocument.defaultView || window;
    var val = win.getComputedStyle(node).getPropertyValue(styleProperty);
    return val ? parseFloat(val.replace('px', '')) : 0;
}
function getNodeWidth(node) {
    var leftBorder = px(node, 'border-left-width');
    var rightBorder = px(node, 'border-right-width');
    return node.clientWidth + leftBorder + rightBorder;
}
function getNodeHeight(node) {
    var topBorder = px(node, 'border-top-width');
    var bottomBorder = px(node, 'border-bottom-width');
    return node.clientHeight + topBorder + bottomBorder;
}
function getImageSize(targetNode, options) {
    if (options === void 0) { options = {}; }
    var width = options.width || getNodeWidth(targetNode);
    var height = options.height || getNodeHeight(targetNode);
    return { width: width, height: height };
}
exports.getImageSize = getImageSize;
function getPixelRatio() {
    var ratio;
    var FINAL_PROCESS;
    try {
        FINAL_PROCESS = process;
    }
    catch (e) {
        // pass
    }
    var val = FINAL_PROCESS && FINAL_PROCESS.env
        ? FINAL_PROCESS.env.devicePixelRatio
        : null;
    if (val) {
        ratio = parseInt(val, 10);
        if (Number.isNaN(ratio)) {
            ratio = 1;
        }
    }
    return ratio || window.devicePixelRatio || 1;
}
exports.getPixelRatio = getPixelRatio;
// @see https://developer.mozilla.org/en-US/docs/Web/HTML/Element/canvas#maximum_canvas_size
var canvasDimensionLimit = 16384;
function checkCanvasDimensions(canvas) {
    if (canvas.width > canvasDimensionLimit ||
        canvas.height > canvasDimensionLimit) {
        if (canvas.width > canvasDimensionLimit &&
            canvas.height > canvasDimensionLimit) {
            if (canvas.width > canvas.height) {
                canvas.height *= canvasDimensionLimit / canvas.width;
                canvas.width = canvasDimensionLimit;
            }
            else {
                canvas.width *= canvasDimensionLimit / canvas.height;
                canvas.height = canvasDimensionLimit;
            }
        }
        else if (canvas.width > canvasDimensionLimit) {
            canvas.height *= canvasDimensionLimit / canvas.width;
            canvas.width = canvasDimensionLimit;
        }
        else {
            canvas.width *= canvasDimensionLimit / canvas.height;
            canvas.height = canvasDimensionLimit;
        }
    }
}
exports.checkCanvasDimensions = checkCanvasDimensions;
function canvasToBlob(canvas, options) {
    if (options === void 0) { options = {}; }
    if (canvas.toBlob) {
        return new Promise(function (resolve) {
            canvas.toBlob(resolve, options.type ? options.type : 'image/png', options.quality ? options.quality : 1);
        });
    }
    return new Promise(function (resolve) {
        var binaryString = window.atob(canvas
            .toDataURL(options.type ? options.type : undefined, options.quality ? options.quality : undefined)
            .split(',')[1]);
        var len = binaryString.length;
        var binaryArray = new Uint8Array(len);
        for (var i = 0; i < len; i += 1) {
            binaryArray[i] = binaryString.charCodeAt(i);
        }
        resolve(new Blob([binaryArray], {
            type: options.type ? options.type : 'image/png',
        }));
    });
}
exports.canvasToBlob = canvasToBlob;
function createImage(url) {
    return new Promise(function (resolve, reject) {
        var img = new Image();
        img.onload = function () {
            img.decode().then(function () {
                requestAnimationFrame(function () { return resolve(img); });
            });
        };
        img.onerror = reject;
        img.crossOrigin = 'anonymous';
        img.decoding = 'async';
        img.src = url;
    });
}
exports.createImage = createImage;
function svgToDataURL(svg) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, Promise.resolve()
                    .then(function () { return new XMLSerializer().serializeToString(svg); })
                    .then(encodeURIComponent)
                    .then(function (html) { return "data:image/svg+xml;charset=utf-8,".concat(html); })];
        });
    });
}
exports.svgToDataURL = svgToDataURL;
function nodeToDataURL(node, width, height) {
    return __awaiter(this, void 0, void 0, function () {
        var xmlns, svg, foreignObject;
        return __generator(this, function (_a) {
            xmlns = 'http://www.w3.org/2000/svg';
            svg = document.createElementNS(xmlns, 'svg');
            foreignObject = document.createElementNS(xmlns, 'foreignObject');
            svg.setAttribute('width', "".concat(width));
            svg.setAttribute('height', "".concat(height));
            svg.setAttribute('viewBox', "0 0 ".concat(width, " ").concat(height));
            foreignObject.setAttribute('width', '100%');
            foreignObject.setAttribute('height', '100%');
            foreignObject.setAttribute('x', '0');
            foreignObject.setAttribute('y', '0');
            foreignObject.setAttribute('externalResourcesRequired', 'true');
            svg.appendChild(foreignObject);
            foreignObject.appendChild(node);
            return [2 /*return*/, svgToDataURL(svg)];
        });
    });
}
exports.nodeToDataURL = nodeToDataURL;
var isInstanceOfElement = function (node, instance) {
    if (node instanceof instance)
        return true;
    var nodePrototype = Object.getPrototypeOf(node);
    if (nodePrototype === null)
        return false;
    return (nodePrototype.constructor.name === instance.name ||
        (0, exports.isInstanceOfElement)(nodePrototype, instance));
};
exports.isInstanceOfElement = isInstanceOfElement;
//# sourceMappingURL=util.js.map
}).call(this,require("Wb8Gej"))
},{"Wb8Gej":2}]},{},[1])